// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/hero-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  scroll-behavior: smooth;
}

a {
  color: var(--color-links);
  text-decoration: none;
}

a:hover {
  color: var(--color-links-hover);
  text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-primary);
}

#preloader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  overflow: hidden;
  background: var(--color-white);
  transition: all 0.6s ease-out;
  width: 100%;
  height: 100vh;
}
#preloader:before, #preloader:after {
  content: "";
  position: absolute;
  border: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: animate-preloader 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
#preloader:after {
  animation-delay: -0.5s;
}

@keyframes animate-preloader {
  0% {
    width: 10px;
    height: 10px;
    top: calc(50% - 5px);
    left: calc(50% - 5px);
    opacity: 1;
  }
  100% {
    width: 72px;
    height: 72px;
    top: calc(50% - 36px);
    left: calc(50% - 36px);
    opacity: 0;
  }
}

section {
  padding: 60px 0;
  overflow: hidden;
}

.section-header {
  text-align: center;
  padding-bottom: 40px;
}
.section-header h2 {
  font-size: 48px;
  font-weight: 300;
  margin-bottom: 20px;
  color: var(--color-secondary);
}
.section-header p {
  margin: 0 auto;
  color: var(--color-secondary-light);
}
@media (min-width: 1280px) {
  .section-header p {
    max-width: 80%;
  }
}


.cta {
  padding: 0;
  margin-bottom: 60px;
}

.cta .container {
  padding:20px 40px 20px 20px ;
  background: rgba(var(--color-secondary-rgb), 0.1);
  border-radius: 15px;
}

@media (max-width: 992px) {
  .cta .container {
    padding: 60px;
  }
}

.cta .content h3 {
  color:#302ba0;
  font-size:13px;
  font-weight: 600;
  line-height:30px;
}
.cta .content span i{height:30px; width:30px; margin:0px 10px 0px 0px; text-align:center; background:#fff; color:#302ba0; display:inline-block; 
box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1); border-radius:50%; font-weight:bold;}
.cta .content h3 a{color:#302ba0;}
.cta .content h3 a:hover{color:#000;}

.cta .content h3 em {
  font-style: normal;
  position: relative;
}

.cta .content h3 em:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
  height: 10px;
  background: rgba(var(--color-primary-rgb), 0.5);
  z-index: -1;
}

.cta .content p {
  color: var(--color-secondary);
  font-weight: 600;
  font-size: 18px;
}

.cta .content .cta-btn {
  color: var(--color-white);
  font-weight: 500;
  font-size: 16px;
  display: inline-block;
  padding: 12px 40px;
  border-radius: 5px;
  transition: 0.5s;
  margin-top: 10px;
  background: rgba(var(--color-primary-dark-rgb), 0.9);
}

.cta .content .cta-btn:hover {
  background: var(--color-primary);
}

.cta .img {
  position: relative;
}

.cta .img:before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--color-white-rgb), 0.5);
  border-radius: 15px;
  transform: rotate(12deg);
}

.cta .img:after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--color-white-rgb), 0.9);
  border-radius: 15px;
  transform: rotate(6deg);
}

.cta .img img {
  position: relative;
  z-index: 3;
  border-radius: 15px;
  
}

.inner1 {
  padding: 15px 0;
  background: rgba(var(--color-secondary-rgb), 0.05);
  min-height: 40px;
  margin-top: 130px;
}
.inner1 h2 {
  font-size: 30px;
  font-weight: 300;
  margin: 0;
}
.inner1 ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
}
.inner1 ol li + li {
  padding-left: 10px;
}
.inner1 ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: var(--color-secondary-light);
  content: "/";
}
@media (max-width: 992px) {
  .inner1 .d-flex {
    display: block !important;
  }
  .inner1 h2 {
    margin-bottom: 10px;
    font-size: 24px;
  }
  .inner1 ol {
    display: block;
  }
  .inner1 ol li {
    display: inline-block;
  }
}

.scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 995;
  background:#ffde00;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  transition: all 0.4s;
}
.scroll-top i {
  font-size: 24px;
  color: var(--color-white);
  line-height: 0;
}
.scroll-top:hover {
  background: rgba(var(--color-primary-rgb), 0.85);
  color: var(--color-white);
}
.scroll-top.active {
  visibility: visible;
  opacity: 1;
}

@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

.header {
  padding: 15px 0;
  transition: all 0.5s;
  z-index: 997;
}
.header.sticked {
  background: rgba(var(--bs-body-color-rgb), 0.9);
  box-shadow: 0px 2px 20px rgba(var(--color-secondary-rgb), 0.1);
}
.header .logo img {
  max-height: 40px;
  margin-right: 6px;
}
.header .logo h1 {
  font-size: 32px;
  font-weight: 300;
  color: var(--color-secondary);
  font-family: var(--font-secondary);
}
.header .logo h1 span {
  color: var(--color-primary);
  font-weight: 500;
}
.header .btn-getstarted, .header .btn-getstarted:focus {
  font-size: 16px;
  color: var(--color-white);
  background: var(--color-primary);
  padding: 8px 23px;
  border-radius: 4px;
  transition: 0.3s;
  font-family: var(--font-secondary);
}
.header .btn-getstarted:hover, .header .btn-getstarted:focus:hover {
  color: var(--color-white);
  background: rgba(var(--color-primary-rgb), 0.85);
}
@media (max-width: 1279px) {
  .header .btn-getstarted, .header .btn-getstarted:focus {
    margin-right: 50px;
  }
}

/* @media (min-width: 1280px) {
  .navbar {
    padding: 0;
    position: relative;
  }

  .navbar ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
  }
  .navbar{justify-content: right;}

  .navbar li {
    position: relative;
  }

  .navbar>ul>li {
    white-space: nowrap;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    font-family: var(--font-secondary);
    font-size: 16px;
    font-weight: 400;
    color: rgba(var(--color-secondary-dark-rgb), 0.7);
    white-space: nowrap;
    transition: 0.3s;
    position: relative;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar>ul>li>a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: var(--color-primary);
    visibility: hidden;
    transition: all 0.3s ease-in-out 0s;
    transform: scaleX(0);
    transition: all 0.3s ease-in-out 0s;
  }

  .navbar a:hover:before,
  .navbar li:hover>a:before,
  .navbar .active:before {
    visibility: visible;
    transform: scaleX(0.7);
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover>a {
    color: var(--color-primary);
  }

  .navbar .dropdown a:hover:before,
  .navbar .dropdown:hover>a:before,
  .navbar .dropdown .active:before {
    visibility: hidden;
  }

  .navbar .dropdown a:hover,
  .navbar .dropdown .active,
  .navbar .dropdown .active:focus,
  .navbar .dropdown:hover>a {
    color: var(--color-white);
    background: rgba(var(--bs-body-color-rgb), 0.9);
  }

  .navbar .dropdown ul {
    display: block;
    position: absolute;
    left: 0;
    top: 100%;
    margin: 0;
    padding: 0 0 10px 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    background:#000;
    transition: 0.3s;
  }

  .navbar .dropdown ul li {
    min-width: 200px;
  }

  .navbar .dropdown ul a {
    padding: 10px 20px;
    font-size: 15px;
    text-transform: none;
    font-weight: 400;
    color: rgba(var(--color-white-rgb), 0.5);
  }

  .navbar .dropdown ul a i {
    font-size: 12px;
  }

  .navbar .dropdown ul a:hover,
  .navbar .dropdown ul .active,
  .navbar .dropdown ul .active:hover,
  .navbar .dropdown ul li:hover>a {
    color: var(--color-white);
    background: var(--color-primary);
  }

  .navbar .dropdown:hover>ul {
    opacity: 1;
    visibility: visible;
  }

  .navbar .megamenu {
    position: static;
  }

  .navbar .megamenu ul {
    right: 0;
    padding: 10px;
    display: flex;
  }

  .navbar .megamenu ul li {
    flex: 1;
  }

  .navbar .megamenu ul li a,
  .navbar .megamenu ul li:hover>a {
    color: rgba(var(--color-white-rgb), 0.5);
    background: none;
  }

  .navbar .megamenu ul li a:hover,
  .navbar .megamenu ul li .active,
  .navbar .megamenu ul li .active:hover {
    color: var(--color-white);
    background: var(--color-primary);
  }

  .navbar .dropdown .dropdown ul {
    top: 0;
    left: calc(100% - 30px);
    visibility: hidden;
  }

  .navbar .dropdown .dropdown:hover>ul {
    opacity: 1;
    top: 0;
    left: 100%;
    visibility: visible;
  }
} */

/* @media (min-width: 1280px) and (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover>ul {
    left: -100%;
  }
}


@media (max-width: 1279px) {
  .navbar {
    position: fixed !important;
    top: 0 !important;
    left: -100% ;
    width: calc(100% - 70px);
    bottom: 0 !important;
    transition: 0.3s;
    z-index: 9997 !important;
  }

  .navbar ul {
    position: absolute;
    inset: 0;
    padding: 10px 0;
    margin: 0;
    background: rgba(var(--color-secondary-rgb), 0.9);
    overflow-y: auto;
    transition: 0.3s;
    z-index: 9998;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(var(--color-white-rgb), 0.7);
    white-space: nowrap;
    transition: 0.3s;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover>a {
    color: var(--color-white);
  }

  .navbar .dropdown ul,
  .navbar .dropdown .dropdown ul {
    position: static;
    display: none;
    padding: 10px 0;
    margin: 10px 20px;
    transition: all 0.5s ease-in-out;
    border: 1px solid rgba(var(--color-secondary-light-rgb), 0.3);
  }

  .navbar .dropdown>.dropdown-active,
  .navbar .dropdown .dropdown>.dropdown-active {
    display: block;
  }

  .mobile-nav-toggle {
    display: block !important;
    color: var(--color-secondary);
    font-size: 28px;
    cursor: pointer;
    line-height: 0;
    transition: 0.5s;
    position: fixed;
    top: 20px;
    z-index: 9999;
    right: 20px;
  }

  .mobile-nav-toggle.bi-x {
    color: var(--color-white);
  }

  .mobile-nav-active {
    overflow: hidden;
    z-index: 9995;
    position: relative;
  }

  .mobile-nav-active .navbar {
    left: 0;
  }

  .mobile-nav-active .navbar:before {
    content: "";
    position: fixed;
    inset: 0;
    background: rgba(var(--color-secondary-rgb), 0.8);
    z-index: 9996;
  }
} */


.hero {
  width: 100%;
  min-height: 60vh;
  padding: 0;
  background: var(--color-black);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 140px 0 60px 0;
}
@media (max-width: 640px) {
  .hero .container {
    padding: 0 60px;
  }
}
.hero h2 {
  color: var(--color-secondary);
  margin-bottom: 25px;
  font-size: 48px;
  font-weight: 300;
  animation: fadeInDown 1s both 0.2s;
}
@media (max-width: 768px) {
  .hero h2 {
    font-size: 30px;
  }
}
.hero p {

  color: rgba(var(--color-white-rgb), 0.7);
  animation: fadeInDown 1s both 0.4s;
  font-weight: 500;
  margin-bottom: 30px;
}
.hero .img {
  margin-bottom: 40px;
  animation: fadeInDownLite 1s both;
}
.hero .btn-get-started {
  font-family: var(--font-secondary);
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 8px 32px;
  border-radius: 5px;
  transition: 0.5s;
  animation: fadeInUp 1s both 0.6s;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}
.hero .btn-get-started:hover {
  background: var(--color-primary);
  color: var(--color-white);
}
.hero .carousel-control-prev {
  justify-content: start;
}
@media (min-width: 640px) {
  .hero .carousel-control-prev {
    padding-left: 15px;
  }
}
.hero .carousel-control-next {
  justify-content: end;
}
@media (min-width: 640px) {
  .hero .carousel-control-next {
    padding-right: 15px;
  }
}
.hero .carousel-control-next-icon, .hero .carousel-control-prev-icon {
  background: none;
  font-size: 26px;
  line-height: 0;
  background: rgba(var(--color-secondary-rgb), 0.4);
  color: rgba(var(--color-white-rgb), 0.98);
  border-radius: 50px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero .carousel-control-next-icon {
  padding-left: 3px;
}
.hero .carousel-control-prev-icon {
  padding-right: 3px;
}
.hero .carousel-control-prev, .hero .carousel-control-next {
  transition: 0.3s;
}
.hero .carousel-control-prev:focus, .hero .carousel-control-next:focus {
  opacity: 0.5;
}
.hero .carousel-control-prev:hover, .hero .carousel-control-next:hover {
  opacity: 0.9;
}
.hero .carousel-indicators li {
  cursor: pointer;
  background: rgba(255,255,255, 0.8);
  overflow: hidden;
  border: 0;
  width: 12px;
  height: 12px;
  border-radius: 50px;
  opacity: 0.6;
  transition: 0.3s;
}
.hero .carousel-indicators li.active {
  opacity: 1;
  background: #ffec69;
  width: 26px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInDownLite {
  from {
    opacity: 0;
    transform: translate3d(0, -10%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.featured-services .service-item {
  padding: 30px;
  transition: all ease-in-out 0.4s;
  background: var(--color-white);
  height: 100%;
}
.featured-services .service-item .icon {
  margin-bottom: 10px;
}
.featured-services .service-item .icon i {
  color: var(--color-primary);
  font-size: 36px;
  transition: 0.3s;
}
.featured-services .service-item h4 {
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 24px;
}
.featured-services .service-item h4 a {
  color: var(--color-secondary);
  transition: ease-in-out 0.3s;
}
.featured-services .service-item p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}
.featured-services .service-item:hover {
  transform: translateY(-10px);
  box-shadow: 0px 0 60px 0 rgba(var(--color-secondary-rgb), 0.1);
}
.featured-services .service-item:hover h4 a {
  color: var(--color-primary);
}


.about .about-img {
  position: relative;
}

.about .about-img img{width:100%;}

@media (max-width: 575px) {
  .about .about-img {
    margin: 30px 0 0 30px;
  }
  .about .about-img:before {
    inset: -30px 0 0 -30px;
  }
}
.about h3 {
  color: var(--color-secondary);
  font-family: var(--font-secondary);
  font-weight: 300;
  font-size: 32px;
  margin-bottom: 20px;
}
@media (max-width: 768px) {
  .about h3 {
    font-size: 28px;
  }
}
.about .nav-pills {
  border-bottom: 1px solid rgba(var(--color-secondary-rgb), 0.2);
}
.about .nav-pills li + li {
  margin-left: 40px;
}
.about .nav-link {
  background: none;
  font-size: 18px;
  font-weight: 400;
  color: var(--color-secondary);
  padding: 12px 0;
  margin-bottom: -2px;
  border-radius: 0;
  font-family: var(--font-secondary);
}
.about .nav-link.active {
  color: var(--color-primary);
  background: none;
  border-bottom: 3px solid var(--color-primary);
}
@media (max-width: 575px) {
  .about .nav-link {
    font-size: 16px;
  }
}
.about .tab-content h4 {
  font-size: 18px;
  margin: 0;
  font-weight: 700;
  color: var(--color-secondary);
}
.about .tab-content i {
  font-size: 22px;
  line-height: 0;
  margin-right: 8px;
  color: var(--color-primary);
}


.onfocus {
  padding: 0;
}

@media (min-width: 768px) {
  .onfocus .content {
    padding: 80px;
  }
}
.onfocus .content h3 {
  font-weight: 600;
  font-size: 32px;
  color: var(--color-white);
}
.onfocus .content ul {
  list-style: none;
  padding: 0;
}
.onfocus .content ul li {
  padding-bottom: 10px;
}
.onfocus .content ul i {
  font-size: 20px;
  padding-right: 4px;
  color: var(--color-primary);
}
.onfocus .content p:last-child {
  margin-bottom: 0;
}
.onfocus .content .read-more {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  padding: 12px 24px;
  border-radius: 5px;
  transition: 0.3s;
  display: -nline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-white);
  background: var(--color-primary);
}
.onfocus .content .read-more i {
  font-size: 18px;
  margin-left: 5px;
  line-height: 0;
  transition: 0.3s;
}
.onfocus .content .read-more:hover {
  background: rgba(var(--color-primary-rgb), 0.9);
  padding-right: 19px;
}
.onfocus .content .read-more:hover i {
  margin-left: 10px;
}
.onfocus .play-btn {
  width: 94px;
  height: 94px;
  background: radial-gradient(var(--color-primary) 50%, rgba(var(--color-primary-rgb), 0.4) 52%);
  border-radius: 50%;
  display: block;
  position: absolute;
  left: calc(50% - 47px);
  top: calc(50% - 47px);
  overflow: hidden;
}
.onfocus .play-btn:before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  animation-delay: 0s;
  animation: pulsate-btn 2s;
  animation-direction: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: steps;
  opacity: 1;
  border-radius: 50%;
  border: 5px solid rgba(var(--color-primary-rgb), 0.7);
  top: -15%;
  left: -15%;
  background: rgba(198, 16, 0, 0);
}
.onfocus .play-btn:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid var(--color-white);
  z-index: 100;
  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.onfocus .play-btn:hover:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border: none;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid var(--color-white);
  z-index: 200;
  animation: none;
  border-radius: 0;
}
.onfocus .play-btn:hover:after {
  border-left: 15px solid var(--color-primary);
  transform: scale(20);
}

@keyframes pulsate-btn {
  0% {
    transform: scale(0.6, 0.6);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}

.features .nav-tabs {
  border: 0;
}
.features .nav-link {
  border: 0;
  padding: 25px 20px;
  color: var(--color-secondary);
  box-shadow: 5px 5px 25px rgba(var(--color-secondary-rgb), 0.15);
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: 0s;
  cursor: pointer;
  height: 100%;
}
.features .nav-link i {
  font-size: 32px;
  line-height: 0;
}
.features .nav-link h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0 0 0;
  color: var(--color-secondary);
}
.features .nav-link:hover {
  color: var(--color-primary);
}
.features .nav-link.active {
  transition: 0.3s;
  background: var(--color-red) linear-gradient(rgba(var(--color-primary-rgb), 0.95), rgba(var(--color-primary-rgb), 0.6));
  border-color: var(--color-primary);
}
.features .nav-link.active h4 {
  color: var(--color-white);
}
.features .nav-link.active i {
  color: var(--color-white) !important;
}
.features .tab-content {
  margin-top: 30px;
}
.features .tab-pane.active {
  animation: fadeIn 0.5s ease-out;
}
.features .tab-pane h3 {
  font-weight: 600;
  font-size: 36px;
  color: var(--color-secondary);
}
.features .tab-pane ul {
  list-style: none;
  padding: 0;
}
.features .tab-pane ul li {
  padding-bottom: 10px;
}
.features .tab-pane ul i {
  font-size: 24px;
  margin-right: 4px;
  color: var(--color-primary);
}
.features .tab-pane p:last-child {
  margin-bottom: 0;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.services .img {
  border-radius: 8px;
  overflow: hidden;
}
.services .img img {
  transition: 0.6s;
}
.services .details {
  height:85px;
  padding: 11px 10px;
  margin: -33px 30px 0 30px;
  transition: all ease-in-out 0.3s;
  background: var(--color-white);
  position: relative;
  background: rgba(var(--color-white-rgb), 0.9);
  text-align: center;
  border-radius: 8px;
  box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);
}
.services .details .icon {
  margin: 0;
  width:62px;
  height: 62px;
  background: var(--color-primary);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: var(--color-white);
  font-size: 25px;
  transition: ease-in-out 0.3s;
  position: absolute;
  top: -40px;
  left: calc(50% - 36px);
  border: 6px solid var(--color-white);
}
.services .details h3 {
  color: var(--color-default);
  font-weight: 700;
  margin:22px 0 8px 0;
  font-size:16px;
  transition: ease-in-out 0.3s;
}
.services .details p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}
.services .service-item:hover .details h3 {
  color: var(--color-primary);
}
.services .service-item:hover .details .icon {
  background: var(--color-white);
  border: 2px solid var(--color-primary);
}
.services .service-item:hover .details .icon i {
  color: var(--color-primary);
}
.services .service-item:hover .img img {
  transform: scale(1.2);
}

.testimonials::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--color-secondary-dark-rgb), 0.8);
}
.testimonials .section-header {
  margin-bottom: 40px;
}
.testimonials .testimonials-carousel, .testimonials .testimonials-slider {
  overflow: hidden;
}
.testimonials .testimonial-item {
  text-align: center;
  color: var(--color-white);
}
.testimonials .testimonial-item .testimonial-img {
  width: 100px;
  border-radius: 50%;
  border: 6px solid rgba(var(--color-white-rgb), 0.15);
  margin: 0 auto;
}
.testimonials .testimonial-item h3 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: var(--color-white);
}
.testimonials .testimonial-item h4 {
  font-size: 14px;
  color: rgba(var(--color-white-rgb), 0.6);
  margin: 0 0 15px 0;
}
.testimonials .testimonial-item .stars {
  margin-bottom: 15px;
}
.testimonials .testimonial-item .stars i {
  color: var(--color-yellow);
  margin: 0 1px;
}
.testimonials .testimonial-item .quote-icon-left, .testimonials .testimonial-item .quote-icon-right {
  color: rgba(var(--color-white-rgb), 0.6);
  font-size: 26px;
  line-height: 0;
}
.testimonials .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}
.testimonials .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
  transform: scale(-1, -1);
}
.testimonials .testimonial-item p {
  font-style: italic;
  margin: 0 auto 15px auto;
}
.testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}
.testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: rgba(var(--color-white-rgb), 0.4);
  opacity: 0.5;
}
.testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--color-white);
  opacity: 1;
}
@media (min-width: 992px) {
  .testimonials .testimonial-item p {
    width: 80%;
  }
}


.pricing {
  background: rgba(var(--color-secondary-rgb), 0.04);
}
.pricing .pricing-item {
  padding: 60px 40px;
  box-shadow: 0 3px 20px -2px rgba(var(--color-gray-rgb), 0.15);
  background: var(--color-white);
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 4px solid var(--color-white);
  border-radius: 10px;
  overflow: hidden;
}

.pricing h3 {
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 36px;
  color: var(--color-white);
}
.pricing h4 {
  font-size: 48px;
  color: var(--color-white);
  font-weight: 400;
  font-family: var(--font-primary);
  margin-bottom: 0;
}
.pricing h4 sup {
  font-size: 28px;
}
.pricing h4 span {
  color: rgba(var(--color-white-rgb), 0.6);
  font-size: 24px;
}
.pricing ul {
  padding: 30px 0;
  list-style: none;
  color: var(--color-gray);
  text-align: left;
  line-height: 20px;
}
.pricing ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.pricing ul i {
  color: var(--color-primary);
  font-size: 36px;
  padding-right: 3px;
  line-height: 0;
}
.pricing ul .na {
  color: rgba(var(--color-gray-rgb), 0.5);
}
.pricing ul .na i {
  color: rgba(var(--color-gray-rgb), 0.5);
  font-size: 24px;
  padding-left: 4px;
}
.pricing ul .na span {
  text-decoration: line-through;
}
.pricing .buy-btn {
  display: inline-block;
  padding: 12px 40px;
  border-radius: 6px;
  color: var(--color-primary);
  transition: none;
  font-size: 16px;
  font-weight: 700;
  transition: 0.3s;
  border: 1px solid var(--color-primary);
}
.pricing .buy-btn:hover {
  background: var(--color-primary);
  color: var(--color-white);
}
.pricing .featured {
  border-color: var(--color-primary);
}

.pricing .featured .buy-btn {
  background: var(--color-primary);
  color: var(--color-white);
}

@media (max-width: 991px) {
  .faq {
    padding: 0;
  }
}
.faq .content h3 {
  font-weight: 400;
  font-size: 34px;
  color: var(--color-secondary);
}
.faq .content h4 {
  font-size: 20px;
  font-weight: 700;
  margin-top: 5px;
}
.faq .content p {
  font-size: 15px;
  color: var(--color-gray);
}
.faq .img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: 400px;
}
.faq .accordion-item {
  border: 0;
  margin-top: 15px;
  box-shadow: 0px 5px 25px 0px rgba(var(--color-black-rgb), 0.06);
}
.faq .accordion-collapse {
  border: 0;
}
.faq .accordion-button {
  padding: 15px 20px 20px 20px;
  font-weight: 600;
  border: 0;
  font-size: 16px;
  color: var(--color-default);
  text-align: left;
  background: var(--color-white);
  box-shadow: none;
  border-radius: 5px;
}
.faq .accordion-button:not(.collapsed) {
  color: var(--color-primary);
  border-bottom: 0;
  box-shadow: none;
}
.faq .question-icon {
  position: absolute;
  top: 14px;
  left: 25px;
  font-size: 20px;
  color: var(--color-primary);
}
.faq .accordion-button:after {
  position: absolute;
  right: 15px;
  top: 15px;
  color: var(--color-primary);
}
.faq .accordion-body {
  padding: 0 30px 25px 20px;
  border: 0;
  border-radius: 5px;
  background: var(--color-white);
  box-shadow: none;
}


.portfolio .portfolio-flters {
  padding: 0;
  margin: 0 auto 30px auto;
  list-style: none;
  text-align: center;
}
.portfolio .portfolio-flters li {
  cursor: pointer;
  display: inline-block;
  padding: 0;
  font-size: 18px;
  font-weight: 300;
  margin: 0 10px;
  line-height: 1;
  margin-bottom: 5px;
  transition: all 0.3s ease-in-out;
}
.portfolio .portfolio-flters li:hover, .portfolio .portfolio-flters li.filter-active {
  color: var(--color-primary);
}
.portfolio .portfolio-flters li:first-child {
  margin-left: 0;
}
.portfolio .portfolio-flters li:last-child {
  margin-right: 0;
}
@media (max-width: 575px) {
  .portfolio .portfolio-flters li {
    font-size: 14px;
    margin: 0 5px;
  }
}
.portfolio .portfolio-item {
  position: relative;
  border: 1px solid var(--color-white);
  overflow: hidden;
  z-index: 1;
}
.portfolio .portfolio-item img {
  transition: all 0.3s;
}
.portfolio .portfolio-item:before {
  content: "";
  inset: 0;
  position: absolute;
  background: rgba(var(--color-secondary-rgb), 0.8);
  z-index: 2;
  transition: 0.5s;
  visibility: hidden;
  opacity: 0;
}
.portfolio .portfolio-item .portfolio-info {
  opacity: 0;
  position: absolute;
  inset: auto 40px 40px 40px;
  z-index: 3;
  transition: all ease-in-out 0.3s;
  padding: 20px;
}
.portfolio .portfolio-item .portfolio-info h4 {
  font-size: 10px;
  font-weight:normal;
  color: var(--color-white);
  padding-right: 50px;
}
.portfolio .portfolio-item .portfolio-info .preview-link, .portfolio .portfolio-item .portfolio-info .details-link {
  position: absolute;
  right: 50px;
  font-size: 24px;
  top: calc(50% - 14px);
  color: rgba(var(--color-white-rgb), 0.7);
  transition: 0.3s;
  line-height: 0;
}
.portfolio .portfolio-item .portfolio-info .preview-link:hover, .portfolio .portfolio-item .portfolio-info .details-link:hover {
  color: var(--color-white);
}
.portfolio .portfolio-item .portfolio-info .details-link {
  right: 14px;
  font-size: 28px;
}
.portfolio .portfolio-item:hover:before {
  visibility: visible;
  opacity: 1;
}
.portfolio .portfolio-item:hover img {
  transform: scale(1.2);
}
.portfolio .portfolio-item:hover .portfolio-info {
  opacity: 1;
  inset: auto 10px 0 10px;
}

.team .team-member .member-img {
  border-radius: 8px;
  overflow: hidden;
}
.team .team-member .social {
  position: absolute;
  left: 0;
  top: -18px;
  right: 0;
  opacity: 0;
  transition: ease-in-out 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.team .team-member .social a {
  transition: color 0.3s;
  color: var(--color-white);
  background: var(--color-primary);
  margin: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: 0.3s;
}
.team .team-member .social a i {
  line-height: 0;
  font-size: 16px;
}
.team .team-member .social a:hover {
  background: var(--color-primary-light);
}
.team .team-member .social i {
  font-size: 18px;
  margin: 0 2px;
}
.team .team-member .member-info {
  padding: 30px 15px;
  text-align: center;
  box-shadow: 0px 2px 15px rgba(var(--color-black-rgb), 0.1);
  background: var(--color-white);
  margin: -50px 20px 0 20px;
  position: relative;
  border-radius: 8px;
}
.team .team-member .member-info h4 {
  font-weight: 400;
  margin-bottom: 5px;
  font-size: 24px;
  color: var(--color-secondary);
}
.team .team-member .member-info span {
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: var(--color-gray);
}
.team .team-member .member-info p {
  font-style: italic;
  font-size: 14px;
  line-height: 26px;
  color: var(--color-gray);
}
.team .team-member:hover .social {
  opacity: 1;
}

.recent-blog-posts .post-box {
  transition: 0.3s;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}
.recent-blog-posts .post-box .post-img {
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.recent-blog-posts .post-box .post-img img {
  transition: 0.5s;
}
.recent-blog-posts .post-box .meta {
  margin-top: 15px;
}
.recent-blog-posts .post-box .meta .post-date {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-primary);
}
.recent-blog-posts .post-box .meta .post-author {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-secondary);
}
.recent-blog-posts .post-box .post-title {
  font-size: 24px;
  color: var(--color-secondary);
  font-weight: 700;
  margin: 15px 0 0 0;
  position: relative;
  transition: 0.3s;
}
.recent-blog-posts .post-box p {
  margin: 15px 0 0 0;
  color: rgba(var(--color-secondary-dark-rgb), 0.7);
}
.recent-blog-posts .post-box .readmore {
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: 1;
  transition: 0.3s;
  margin-top: 15px;
}
.recent-blog-posts .post-box .readmore i {
  line-height: 0;
  margin-left: 4px;
  font-size: 18px;
}
.recent-blog-posts .post-box:hover .post-title {
  color: var(--color-primary);
}
.recent-blog-posts .post-box:hover .post-img img {
  transform: scale(1.1);
}

.contact .map {
  margin-bottom: 40px;
}
.contact .map iframe {
  border: 0;
  width: 100%;
  height: 400px;
}
.contact .info {
  padding: 40px;
  box-shadow: 0px 2px 15px rgba(var(--color-black-rgb), 0.1);
  overflow: hidden;
}
.contact .info h3 {
  font-weight: 600;
  font-size: 24px;
}
.contact .info p {
  color: var(--color-secondary-light);
  margin-bottom: 30px;
  font-size: 15px;
}
.contact .info-item + .info-item {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid rgba(var(--color-secondary-rgb), 0.15);
}
.contact .info-item i {
  font-size: 24px;
  color: var(--color-primary);
  transition: all 0.3s ease-in-out;
  margin-right: 20px;
}
.contact .info-item h4 {
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
  color: var(--color-secondary);
}
.contact .info-item p {
  padding: 0;
  margin-bottom: 0;
  font-size: 14px;
  color: var(--color-secondary-light);
}
.contact .php-email-form {
  width: 100%;
  background: var(--color-white);
}
.contact .php-email-form .form-group {
  padding-bottom: 8px;
}
.contact .php-email-form .error-message {
  display: none;
  color: var(--color-white);
  background: var(--color-red);
  text-align: left;
  padding: 15px;
  font-weight: 600;
}
.contact .php-email-form .error-message br + br {
  margin-top: 25px;
}
.contact .php-email-form .sent-message {
  display: none;
  color: var(--color-white);
  background: var(--color-green);
  text-align: center;
  padding: 15px;
  font-weight: 600;
}
.contact .php-email-form .loading {
  display: none;
  background: var(--color-white);
  text-align: center;
  padding: 15px;
}
.contact .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid var(--color-green);
  border-top-color: var(--color-white);
  animation: animate-loading 1s linear infinite;
}
.contact .php-email-form input[type=text], .contact .php-email-form input[type=email], .contact .php-email-form textarea {
  border-radius: 0px;
  box-shadow: none;
  font-size: 14px;
}
.contact .php-email-form input[type=text]:focus, .contact .php-email-form input[type=email]:focus, .contact .php-email-form textarea:focus {
  border-color: var(--color-secondary-light);
}
.contact .php-email-form input[type=text], .contact .php-email-form input[type=email] {
  height: 48px;
  padding: 10px 15px;
}
.contact .php-email-form textarea {
  padding: 10px 12px;
  height: 290px;
}
.contact .php-email-form button[type=submit] {
  background: var(--color-primary);
  border: 0;
  padding: 13px 50px;
  color: var(--color-white);
  transition: 0.4s;
  border-radius: 0;
}
.contact .php-email-form button[type=submit]:hover {
  background: rgba(var(--color-primary-rgb), 0.85);
}
@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.portfolio-details {
  padding-top: 40px;
}
.portfolio-details .portfolio-details-slider img {
  width: 100%;
}
.portfolio-details .portfolio-details-slider .swiper-pagination {
  margin-top: 20px;
  position: relative;
}
.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: var(--color-white);
  opacity: 1;
  border: 1px solid var(--color-primary);
}
.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--color-primary);
}
.portfolio-details .portfolio-info {
  padding: 30px;
  box-shadow: 0px 0 30px rgba(var(--color-secondary-rgb), 0.15);
}
.portfolio-details .portfolio-info h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-secondary-light);
}
.portfolio-details .portfolio-info ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}
.portfolio-details .portfolio-info ul li + li {
  margin-top: 10px;
}
.portfolio-details .portfolio-description {
  padding-top: 30px;
}
.portfolio-details .portfolio-description h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
}
.portfolio-details .portfolio-description p {
  padding: 0;
}


.blog .posts-list article {
  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);
  padding: 30px;
  height: 100%;
}
.blog .posts-list article + article {
  margin-top: 60px;
}
.blog .posts-list .post-img {
  max-height: 240px;
  margin: -30px -30px 0 -30px;
  overflow: hidden;
}
.blog .posts-list .title {
  font-size: 24px;
  font-weight: 700;
  padding: 0;
  margin: 20px 0 0 0;
}
.blog .posts-list .title a {
  color: var(--color-secondary);
  transition: 0.3s;
}
.blog .posts-list .title a:hover {
  color: var(--color-primary);
}
.blog .posts-list .meta-top {
  margin-top: 20px;
  color: var(--color-gray);
}
.blog .posts-list .meta-top ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  padding: 0;
  margin: 0;
}
.blog .posts-list .meta-top ul li + li {
  padding-left: 20px;
}
.blog .posts-list .meta-top i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  color: rgba(var(--color-primary-rgb), 0.8);
}
.blog .posts-list .meta-top a {
  color: var(--color-gray);
  font-size: 14px;
  display: inline-block;
  line-height: 1;
}
.blog .posts-list .content {
  margin-top: 20px;
}
.blog .posts-list .read-more a {
  display: inline-block;
  background: var(--color-primary);
  color: var(--color-white);
  padding: 8px 30px;
  transition: 0.3s;
  font-size: 14px;
  border-radius: 4px;
}
.blog .posts-list .read-more a:hover {
  background: rgba(var(--color-primary-rgb), 0.8);
}

.blog .blog-details {
  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);
  padding: 30px;
}
.blog .blog-details .post-img {
  margin: -30px -30px 20px -30px;
  overflow: hidden;
}
.blog .blog-details .title {
  font-size: 28px;
  font-weight: 700;
  padding: 0;
  margin: 20px 0 0 0;
  color: var(--color-secondary);
}
.blog .blog-details .content {
  margin-top: 20px;
}
.blog .blog-details .content h3 {
  font-size: 22px;
  margin-top: 30px;
  font-weight: bold;
}
.blog .blog-details .content blockquote {
  overflow: hidden;
  background-color: rgba(var(--color-secondary-rgb), 0.06);
  padding: 60px;
  position: relative;
  text-align: center;
  margin: 20px 0;
}
.blog .blog-details .content blockquote p {
  color: var(--color-default);
  line-height: 1.6;
  margin-bottom: 0;
  font-style: italic;
  font-weight: 500;
  font-size: 22px;
}
.blog .blog-details .content blockquote:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--color-secondary);
  margin-top: 20px;
  margin-bottom: 20px;
}
.blog .blog-details .meta-top {
  margin-top: 20px;
  color: var(--color-gray);
}
.blog .blog-details .meta-top ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  padding: 0;
  margin: 0;
}
.blog .blog-details .meta-top ul li + li {
  padding-left: 20px;
}
.blog .blog-details .meta-top i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  color: rgba(var(--color-primary-rgb), 0.8);
}
.blog .blog-details .meta-top a {
  color: var(--color-gray);
  font-size: 14px;
  display: inline-block;
  line-height: 1;
}
.blog .blog-details .meta-bottom {
  padding-top: 10px;
  border-top: 1px solid rgba(var(--color-secondary-rgb), 0.15);
}
.blog .blog-details .meta-bottom i {
  color: var(--color-secondary-light);
  display: inline;
}
.blog .blog-details .meta-bottom a {
  color: rgba(var(--color-secondary-rgb), 0.8);
  transition: 0.3s;
}
.blog .blog-details .meta-bottom a:hover {
  color: var(--color-primary);
}
.blog .blog-details .meta-bottom .cats {
  list-style: none;
  display: inline;
  padding: 0 20px 0 0;
  font-size: 14px;
}
.blog .blog-details .meta-bottom .cats li {
  display: inline-block;
}
.blog .blog-details .meta-bottom .tags {
  list-style: none;
  display: inline;
  padding: 0;
  font-size: 14px;
}
.blog .blog-details .meta-bottom .tags li {
  display: inline-block;
}
.blog .blog-details .meta-bottom .tags li + li::before {
  padding-right: 6px;
  color: var(--color-default);
  content: ",";
}
.blog .blog-details .meta-bottom .share {
  font-size: 16px;
}
.blog .blog-details .meta-bottom .share i {
  padding-left: 5px;
}
.blog .post-author {
  padding: 20px;
  margin-top: 30px;
  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);
}
.blog .post-author img {
  max-width: 120px;
  margin-right: 20px;
}
.blog .post-author h4 {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 0px;
  padding: 0;
  color: var(--color-secondary);
}
.blog .post-author .social-links {
  margin: 0 10px 10px 0;
}
.blog .post-author .social-links a {
  color: rgba(var(--color-secondary-rgb), 0.5);
  margin-right: 5px;
}
.blog .post-author p {
  font-style: italic;
  color: rgba(var(--color-gray-rgb), 0.8);
  margin-bottom: 0;
}

.blog .sidebar {
  padding: 30px;
  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);
}
.blog .sidebar .sidebar-title {
  font-size: 20px;
  font-weight: 700;
  padding: 0;
  margin: 0;
  color: var(--color-secondary);
}
.blog .sidebar .sidebar-item + .sidebar-item {
  margin-top: 40px;
}
.blog .sidebar .search-form form {
  background: var(--color-white);
  border: 1px solid rgba(var(--color-secondary-rgb), 0.3);
  padding: 3px 10px;
  position: relative;
}
.blog .sidebar .search-form form input[type=text] {
  border: 0;
  padding: 4px;
  border-radius: 4px;
  width: calc(100% - 40px);
}
.blog .sidebar .search-form form input[type=text]:focus {
  outline: none;
}
.blog .sidebar .search-form form button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 15px;
  margin: -1px;
  background: var(--color-primary);
  color: var(--color-white);
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
  line-height: 0;
}
.blog .sidebar .search-form form button i {
  line-height: 0;
}
.blog .sidebar .search-form form button:hover {
  background: rgba(var(--color-primary-rgb), 0.8);
}
.blog .sidebar .categories ul {
  list-style: none;
  padding: 0;
}
.blog .sidebar .categories ul li + li {
  padding-top: 10px;
}
.blog .sidebar .categories ul a {
  color: var(--color-secondary);
  transition: 0.3s;
}
.blog .sidebar .categories ul a:hover {
  color: var(--color-default);
}
.blog .sidebar .categories ul a span {
  padding-left: 5px;
  color: rgba(var(--color-default-rgb), 0.4);
  font-size: 14px;
}
.blog .sidebar .recent-posts .post-item {
  display: flex;
}
.blog .sidebar .recent-posts .post-item + .post-item {
  margin-top: 15px;
}
.blog .sidebar .recent-posts img {
  width: 80px;
  margin-right: 15px;
}
.blog .sidebar .recent-posts h4 {
  font-size: 18px;
  font-weight: 400;
}
.blog .sidebar .recent-posts h4 a {
  color: var(--color-secondary);
  transition: 0.3s;
}
.blog .sidebar .recent-posts h4 a:hover {
  color: var(--color-primary);
}
.blog .sidebar .recent-posts time {
  display: block;
  font-style: italic;
  font-size: 14px;
  color: rgba(var(--color-default-rgb), 0.4);
}
.blog .sidebar .tags {
  margin-bottom: -10px;
}
.blog .sidebar .tags ul {
  list-style: none;
  padding: 0;
}
.blog .sidebar .tags ul li {
  display: inline-block;
}
.blog .sidebar .tags ul a {
  color: var(--color-secondary-light);
  font-size: 14px;
  padding: 6px 14px;
  margin: 0 6px 8px 0;
  border: 1px solid rgba(var(--color-secondary-light-rgb), 0.8);
  display: inline-block;
  transition: 0.3s;
}
.blog .sidebar .tags ul a:hover {
  color: var(--color-white);
  border: 1px solid var(--color-primary);
  background: var(--color-primary);
}
.blog .sidebar .tags ul a span {
  padding-left: 5px;
  color: rgba(var(--color-secondary-light-rgb), 0.8);
  font-size: 14px;
}

.blog .comments {
  margin-top: 30px;
}
.blog .comments .comments-count {
  font-weight: bold;
}
.blog .comments .comment {
  margin-top: 30px;
  position: relative;
}
.blog .comments .comment .comment-img {
  margin-right: 14px;
}
.blog .comments .comment .comment-img img {
  width: 60px;
}
.blog .comments .comment h5 {
  font-size: 16px;
  margin-bottom: 2px;
}
.blog .comments .comment h5 a {
  font-weight: bold;
  color: var(--color-default);
  transition: 0.3s;
}
.blog .comments .comment h5 a:hover {
  color: var(--color-primary);
}
.blog .comments .comment h5 .reply {
  padding-left: 10px;
  color: var(--color-secondary);
}
.blog .comments .comment h5 .reply i {
  font-size: 20px;
}
.blog .comments .comment time {
  display: block;
  font-size: 14px;
  color: rgba(var(--color-secondary-rgb), 0.8);
  margin-bottom: 5px;
}
.blog .comments .comment.comment-reply {
  padding-left: 40px;
}
.blog .comments .reply-form {
  margin-top: 30px;
  padding: 30px;
  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);
}
.blog .comments .reply-form h4 {
  font-weight: bold;
  font-size: 22px;
}
.blog .comments .reply-form p {
  font-size: 14px;
}
.blog .comments .reply-form input {
  border-radius: 4px;
  padding: 10px 10px;
  font-size: 14px;
}
.blog .comments .reply-form input:focus {
  box-shadow: none;
  border-color: rgba(var(--color-primary-rgb), 0.8);
}
.blog .comments .reply-form textarea {
  border-radius: 4px;
  padding: 10px 10px;
  font-size: 14px;
}
.blog .comments .reply-form textarea:focus {
  box-shadow: none;
  border-color: rgba(var(--color-primary-rgb), 0.8);
}
.blog .comments .reply-form .form-group {
  margin-bottom: 25px;
}
.blog .comments .reply-form .btn-primary {
  border-radius: 4px;
  padding: 10px 20px;
  border: 0;
  background-color: var(--color-secondary);
}
.blog .comments .reply-form .btn-primary:hover {
  background-color: rgba(var(--color-secondary-rgb), 0.8);
}

.blog .blog-pagination {
  margin-top: 30px;
  color: var(--color-secondary-light);
}
.blog .blog-pagination ul {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}
.blog .blog-pagination li {
  margin: 0 5px;
  transition: 0.3s;
}
.blog .blog-pagination li a {
  color: var(--color-secondary);
  padding: 7px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.blog .blog-pagination li.active, .blog .blog-pagination li:hover {
  background: var(--color-primary);
}
.blog .blog-pagination li.active a, .blog .blog-pagination li:hover a {
  color: var(--color-white);
}

.footer {
  color: var(--color-white);
  font-size: 14px;
}
.footer .footer-content {
  background: var(--color-secondary);
  padding: 30px 0 5px 0;
}
.footer .footer-content .footer-info {
  margin-bottom: 30px;
}
.footer .footer-content .footer-info h3 {
  font-size: 28px;
  margin: 0 0 20px 0;
  padding: 2px 0 2px 0;
  line-height: 1;
  font-weight: 700;
  text-transform: uppercase;
}
.footer .footer-content .footer-info h3 span {
  color: var(--color-primary);
}
.footer .footer-content .footer-info p {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0;
  font-family: var(--font-primary);
  color: var(--color-white);
}
.footer .footer-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-white);
  position: relative;
  padding-bottom: 12px;
  margin-bottom: 15px;
}
.footer .footer-content h4::after {
  content: "";
  position: absolute;
  display: block;
  width: 20px;
  height: 2px;
  background: var(--color-primary);
  bottom: 0;
  left: 0;
}
.footer .footer-content .footer-links {
  margin-bottom:10px;
}
.footer .footer-content .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer .footer-content .footer-links ul i {
  padding-right: 2px;
  color: var(--color-white);
  font-size: 12px;
  line-height: 1;
}
.footer .footer-content .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.footer .footer-content .footer-links ul li:first-child {
  padding-top: 0;
}
.footer .footer-content .footer-links ul a {
  color: rgba(var(--color-white-rgb), 0.7);
  transition: 0.3s;
  display: inline-block;
  line-height: 1;
}
.footer .footer-content .footer-links ul a:hover {
  color: var(--color-white);
}
.footer .footer-content .footer-newsletter form {
  margin-top: 30px;
  background: var(--color-white);
  padding: 6px 10px;
  position: relative;
  border-radius: 4px;
}
.footer .footer-content .footer-newsletter form input[type=email] {
  border: 0;
  padding: 4px;
  width: calc(100% - 110px);
}
.footer .footer-content .footer-newsletter form input[type=email]:focus-visible {
  outline: none;
}
.footer .footer-content .footer-newsletter form input[type=submit] {
  position: absolute;
  top: 0;
  right: -2px;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 20px;
  background: #ffde00;
  color: #000;
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
}
.footer .footer-content .footer-newsletter form input[type=submit]:hover {
  background: rgba(var(--color-primary-rgb), 0.85);
}
.footer .footer-legal {
  padding: 10px 0;
  background: var(--color-secondary-dark);
}
.footer .footer-legal .credits {
  padding-top: 4px;
  font-size: 13px;
  color: var(--color-white);
}
.footer .footer-legal .credits a {
  color: var(--color-primary-light);
}
.footer .footer-legal .social-links a {
  font-size: 18px;
  display: inline-block;
  background: rgba(var(--color-white-rgb), 0.1);
  color: var(--color-white);
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 4px;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}
.footer .footer-legal .social-links a:hover {
  background: var(--color-primary);
  text-decoration: none;
}


.min-high1{ height: 530px !important; overflow: scroll !important; overflow-x: hidden !important;}



`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAElB,qEAAqE;AACvE;AACA;EAEE,sBAAsB;AACxB;;AAmBA;EACE;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE;IACE,cAAc;EAChB;AACF;;;AAGA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA,qBAAqB,WAAW,EAAE,UAAU,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,eAAe,EAAE,aAAa,EAAE,oBAAoB;AAC9I,wDAAwD,EAAE,iBAAiB,EAAE,gBAAgB,CAAC;AAC9F,mBAAmB,aAAa,CAAC;AACjC,yBAAyB,UAAU,CAAC;;AAEpC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6CAA6C;EAC7C,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;;AAErB;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;AACd;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,8DAA8D;AAChE;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyKG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6GG;;;AAGH;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,8BAA8B;EAC9B,iEAAmD;EACnD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAEhB,kCAAkC;AACpC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;EAEE,wCAAwC;EAExC,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EAEnB,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAEhB,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AAWA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AAWA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AAWA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB,UAAU,CAAC;;AAEjC;EACE;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,8DAA8D;AAChE;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8FAA8F;EAC9F,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EAEb,mBAAmB;EAEnB,yBAAyB;EAEzB,6BAA6B;EAE7B,mCAAmC;EAEnC,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,qDAAqD;EACrD,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,4DAA4D;AAC9D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EAEZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAaA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,+DAA+D;EAC/D,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,uHAAuH;EACvH,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EAEE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sDAAsD;AACxD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,+DAA+D;AACjE;AACA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0DAA0D;EAC1D,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4DAA4D;AAC9D;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,oCAAoC;EAEpC,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gDAAgD;AAClD;AASA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,6DAA6D;AAC/D;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,wDAAwD;EACxD,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,wDAAwD;EACxD,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,wDAAwD;EACxD,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,4DAA4D;AAC9D;AACA;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,uDAAuD;EACvD,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,SAAS;EACT,OAAO;AACT;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;;AAGA,YAAY,wBAAwB,EAAE,2BAA2B,EAAE,6BAA6B,CAAC","sourcesContent":["\n:root {\n  scroll-behavior: smooth;\n}\n\na {\n  color: var(--color-links);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--color-links-hover);\n  text-decoration: none;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-primary);\n}\n\n#preloader {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  overflow: hidden;\n  background: var(--color-white);\n  transition: all 0.6s ease-out;\n  width: 100%;\n  height: 100vh;\n}\n#preloader:before, #preloader:after {\n  content: \"\";\n  position: absolute;\n  border: 4px solid var(--color-primary);\n  border-radius: 50%;\n  -webkit-animation: animate-preloader 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n  animation: animate-preloader 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n#preloader:after {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n@-webkit-keyframes animate-preloader {\n  0% {\n    width: 10px;\n    height: 10px;\n    top: calc(50% - 5px);\n    left: calc(50% - 5px);\n    opacity: 1;\n  }\n  100% {\n    width: 72px;\n    height: 72px;\n    top: calc(50% - 36px);\n    left: calc(50% - 36px);\n    opacity: 0;\n  }\n}\n\n@keyframes animate-preloader {\n  0% {\n    width: 10px;\n    height: 10px;\n    top: calc(50% - 5px);\n    left: calc(50% - 5px);\n    opacity: 1;\n  }\n  100% {\n    width: 72px;\n    height: 72px;\n    top: calc(50% - 36px);\n    left: calc(50% - 36px);\n    opacity: 0;\n  }\n}\n\nsection {\n  padding: 60px 0;\n  overflow: hidden;\n}\n\n.section-header {\n  text-align: center;\n  padding-bottom: 40px;\n}\n.section-header h2 {\n  font-size: 48px;\n  font-weight: 300;\n  margin-bottom: 20px;\n  color: var(--color-secondary);\n}\n.section-header p {\n  margin: 0 auto;\n  color: var(--color-secondary-light);\n}\n@media (min-width: 1280px) {\n  .section-header p {\n    max-width: 80%;\n  }\n}\n\n\n.cta {\n  padding: 0;\n  margin-bottom: 60px;\n}\n\n.cta .container {\n  padding:20px 40px 20px 20px ;\n  background: rgba(var(--color-secondary-rgb), 0.1);\n  border-radius: 15px;\n}\n\n@media (max-width: 992px) {\n  .cta .container {\n    padding: 60px;\n  }\n}\n\n.cta .content h3 {\n  color:#302ba0;\n  font-size:13px;\n  font-weight: 600;\n  line-height:30px;\n}\n.cta .content span i{height:30px; width:30px; margin:0px 10px 0px 0px; text-align:center; background:#fff; color:#302ba0; display:inline-block; \nbox-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1); border-radius:50%; font-weight:bold;}\n.cta .content h3 a{color:#302ba0;}\n.cta .content h3 a:hover{color:#000;}\n\n.cta .content h3 em {\n  font-style: normal;\n  position: relative;\n}\n\n.cta .content h3 em:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 10px;\n  height: 10px;\n  background: rgba(var(--color-primary-rgb), 0.5);\n  z-index: -1;\n}\n\n.cta .content p {\n  color: var(--color-secondary);\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.cta .content .cta-btn {\n  color: var(--color-white);\n  font-weight: 500;\n  font-size: 16px;\n  display: inline-block;\n  padding: 12px 40px;\n  border-radius: 5px;\n  transition: 0.5s;\n  margin-top: 10px;\n  background: rgba(var(--color-primary-dark-rgb), 0.9);\n}\n\n.cta .content .cta-btn:hover {\n  background: var(--color-primary);\n}\n\n.cta .img {\n  position: relative;\n}\n\n.cta .img:before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(var(--color-white-rgb), 0.5);\n  border-radius: 15px;\n  transform: rotate(12deg);\n}\n\n.cta .img:after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(var(--color-white-rgb), 0.9);\n  border-radius: 15px;\n  transform: rotate(6deg);\n}\n\n.cta .img img {\n  position: relative;\n  z-index: 3;\n  border-radius: 15px;\n  \n}\n\n.inner1 {\n  padding: 15px 0;\n  background: rgba(var(--color-secondary-rgb), 0.05);\n  min-height: 40px;\n  margin-top: 130px;\n}\n.inner1 h2 {\n  font-size: 30px;\n  font-weight: 300;\n  margin: 0;\n}\n.inner1 ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 14px;\n}\n.inner1 ol li + li {\n  padding-left: 10px;\n}\n.inner1 ol li + li::before {\n  display: inline-block;\n  padding-right: 10px;\n  color: var(--color-secondary-light);\n  content: \"/\";\n}\n@media (max-width: 992px) {\n  .inner1 .d-flex {\n    display: block !important;\n  }\n  .inner1 h2 {\n    margin-bottom: 10px;\n    font-size: 24px;\n  }\n  .inner1 ol {\n    display: block;\n  }\n  .inner1 ol li {\n    display: inline-block;\n  }\n}\n\n.scroll-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: 15px;\n  z-index: 995;\n  background:#ffde00;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  transition: all 0.4s;\n}\n.scroll-top i {\n  font-size: 24px;\n  color: var(--color-white);\n  line-height: 0;\n}\n.scroll-top:hover {\n  background: rgba(var(--color-primary-rgb), 0.85);\n  color: var(--color-white);\n}\n.scroll-top.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n@media screen and (max-width: 768px) {\n  [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n.header {\n  padding: 15px 0;\n  transition: all 0.5s;\n  z-index: 997;\n}\n.header.sticked {\n  background: rgba(var(--bs-body-color-rgb), 0.9);\n  box-shadow: 0px 2px 20px rgba(var(--color-secondary-rgb), 0.1);\n}\n.header .logo img {\n  max-height: 40px;\n  margin-right: 6px;\n}\n.header .logo h1 {\n  font-size: 32px;\n  font-weight: 300;\n  color: var(--color-secondary);\n  font-family: var(--font-secondary);\n}\n.header .logo h1 span {\n  color: var(--color-primary);\n  font-weight: 500;\n}\n.header .btn-getstarted, .header .btn-getstarted:focus {\n  font-size: 16px;\n  color: var(--color-white);\n  background: var(--color-primary);\n  padding: 8px 23px;\n  border-radius: 4px;\n  transition: 0.3s;\n  font-family: var(--font-secondary);\n}\n.header .btn-getstarted:hover, .header .btn-getstarted:focus:hover {\n  color: var(--color-white);\n  background: rgba(var(--color-primary-rgb), 0.85);\n}\n@media (max-width: 1279px) {\n  .header .btn-getstarted, .header .btn-getstarted:focus {\n    margin-right: 50px;\n  }\n}\n\n/* @media (min-width: 1280px) {\n  .navbar {\n    padding: 0;\n    position: relative;\n  }\n\n  .navbar ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    align-items: center;\n  }\n  .navbar{justify-content: right;}\n\n  .navbar li {\n    position: relative;\n  }\n\n  .navbar>ul>li {\n    white-space: nowrap;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    font-family: var(--font-secondary);\n    font-size: 16px;\n    font-weight: 400;\n    color: rgba(var(--color-secondary-dark-rgb), 0.7);\n    white-space: nowrap;\n    transition: 0.3s;\n    position: relative;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar>ul>li>a:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    bottom: 0;\n    left: 0;\n    background-color: var(--color-primary);\n    visibility: hidden;\n    transition: all 0.3s ease-in-out 0s;\n    transform: scaleX(0);\n    transition: all 0.3s ease-in-out 0s;\n  }\n\n  .navbar a:hover:before,\n  .navbar li:hover>a:before,\n  .navbar .active:before {\n    visibility: visible;\n    transform: scaleX(0.7);\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover>a {\n    color: var(--color-primary);\n  }\n\n  .navbar .dropdown a:hover:before,\n  .navbar .dropdown:hover>a:before,\n  .navbar .dropdown .active:before {\n    visibility: hidden;\n  }\n\n  .navbar .dropdown a:hover,\n  .navbar .dropdown .active,\n  .navbar .dropdown .active:focus,\n  .navbar .dropdown:hover>a {\n    color: var(--color-white);\n    background: rgba(var(--bs-body-color-rgb), 0.9);\n  }\n\n  .navbar .dropdown ul {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    margin: 0;\n    padding: 0 0 10px 0;\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    background:#000;\n    transition: 0.3s;\n  }\n\n  .navbar .dropdown ul li {\n    min-width: 200px;\n  }\n\n  .navbar .dropdown ul a {\n    padding: 10px 20px;\n    font-size: 15px;\n    text-transform: none;\n    font-weight: 400;\n    color: rgba(var(--color-white-rgb), 0.5);\n  }\n\n  .navbar .dropdown ul a i {\n    font-size: 12px;\n  }\n\n  .navbar .dropdown ul a:hover,\n  .navbar .dropdown ul .active,\n  .navbar .dropdown ul .active:hover,\n  .navbar .dropdown ul li:hover>a {\n    color: var(--color-white);\n    background: var(--color-primary);\n  }\n\n  .navbar .dropdown:hover>ul {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .navbar .megamenu {\n    position: static;\n  }\n\n  .navbar .megamenu ul {\n    right: 0;\n    padding: 10px;\n    display: flex;\n  }\n\n  .navbar .megamenu ul li {\n    flex: 1;\n  }\n\n  .navbar .megamenu ul li a,\n  .navbar .megamenu ul li:hover>a {\n    color: rgba(var(--color-white-rgb), 0.5);\n    background: none;\n  }\n\n  .navbar .megamenu ul li a:hover,\n  .navbar .megamenu ul li .active,\n  .navbar .megamenu ul li .active:hover {\n    color: var(--color-white);\n    background: var(--color-primary);\n  }\n\n  .navbar .dropdown .dropdown ul {\n    top: 0;\n    left: calc(100% - 30px);\n    visibility: hidden;\n  }\n\n  .navbar .dropdown .dropdown:hover>ul {\n    opacity: 1;\n    top: 0;\n    left: 100%;\n    visibility: visible;\n  }\n} */\n\n/* @media (min-width: 1280px) and (max-width: 1366px) {\n  .navbar .dropdown .dropdown ul {\n    left: -90%;\n  }\n\n  .navbar .dropdown .dropdown:hover>ul {\n    left: -100%;\n  }\n}\n\n\n@media (max-width: 1279px) {\n  .navbar {\n    position: fixed !important;\n    top: 0 !important;\n    left: -100% ;\n    width: calc(100% - 70px);\n    bottom: 0 !important;\n    transition: 0.3s;\n    z-index: 9997 !important;\n  }\n\n  .navbar ul {\n    position: absolute;\n    inset: 0;\n    padding: 10px 0;\n    margin: 0;\n    background: rgba(var(--color-secondary-rgb), 0.9);\n    overflow-y: auto;\n    transition: 0.3s;\n    z-index: 9998;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(var(--color-white-rgb), 0.7);\n    white-space: nowrap;\n    transition: 0.3s;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover>a {\n    color: var(--color-white);\n  }\n\n  .navbar .dropdown ul,\n  .navbar .dropdown .dropdown ul {\n    position: static;\n    display: none;\n    padding: 10px 0;\n    margin: 10px 20px;\n    transition: all 0.5s ease-in-out;\n    border: 1px solid rgba(var(--color-secondary-light-rgb), 0.3);\n  }\n\n  .navbar .dropdown>.dropdown-active,\n  .navbar .dropdown .dropdown>.dropdown-active {\n    display: block;\n  }\n\n  .mobile-nav-toggle {\n    display: block !important;\n    color: var(--color-secondary);\n    font-size: 28px;\n    cursor: pointer;\n    line-height: 0;\n    transition: 0.5s;\n    position: fixed;\n    top: 20px;\n    z-index: 9999;\n    right: 20px;\n  }\n\n  .mobile-nav-toggle.bi-x {\n    color: var(--color-white);\n  }\n\n  .mobile-nav-active {\n    overflow: hidden;\n    z-index: 9995;\n    position: relative;\n  }\n\n  .mobile-nav-active .navbar {\n    left: 0;\n  }\n\n  .mobile-nav-active .navbar:before {\n    content: \"\";\n    position: fixed;\n    inset: 0;\n    background: rgba(var(--color-secondary-rgb), 0.8);\n    z-index: 9996;\n  }\n} */\n\n\n.hero {\n  width: 100%;\n  min-height: 60vh;\n  padding: 0;\n  background: var(--color-black);\n  background: url(\"../img/hero-bg.png\") center center;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 140px 0 60px 0;\n}\n@media (max-width: 640px) {\n  .hero .container {\n    padding: 0 60px;\n  }\n}\n.hero h2 {\n  color: var(--color-secondary);\n  margin-bottom: 25px;\n  font-size: 48px;\n  font-weight: 300;\n  -webkit-animation: fadeInDown 1s both 0.2s;\n  animation: fadeInDown 1s both 0.2s;\n}\n@media (max-width: 768px) {\n  .hero h2 {\n    font-size: 30px;\n  }\n}\n.hero p {\n\n  color: rgba(var(--color-white-rgb), 0.7);\n  -webkit-animation: fadeInDown 1s both 0.4s;\n  animation: fadeInDown 1s both 0.4s;\n  font-weight: 500;\n  margin-bottom: 30px;\n}\n.hero .img {\n  margin-bottom: 40px;\n  -webkit-animation: fadeInDownLite 1s both;\n  animation: fadeInDownLite 1s both;\n}\n.hero .btn-get-started {\n  font-family: var(--font-secondary);\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 8px 32px;\n  border-radius: 5px;\n  transition: 0.5s;\n  -webkit-animation: fadeInUp 1s both 0.6s;\n  animation: fadeInUp 1s both 0.6s;\n  color: var(--color-primary);\n  border: 2px solid var(--color-primary);\n}\n.hero .btn-get-started:hover {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n.hero .carousel-control-prev {\n  justify-content: start;\n}\n@media (min-width: 640px) {\n  .hero .carousel-control-prev {\n    padding-left: 15px;\n  }\n}\n.hero .carousel-control-next {\n  justify-content: end;\n}\n@media (min-width: 640px) {\n  .hero .carousel-control-next {\n    padding-right: 15px;\n  }\n}\n.hero .carousel-control-next-icon, .hero .carousel-control-prev-icon {\n  background: none;\n  font-size: 26px;\n  line-height: 0;\n  background: rgba(var(--color-secondary-rgb), 0.4);\n  color: rgba(var(--color-white-rgb), 0.98);\n  border-radius: 50px;\n  width: 54px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.hero .carousel-control-next-icon {\n  padding-left: 3px;\n}\n.hero .carousel-control-prev-icon {\n  padding-right: 3px;\n}\n.hero .carousel-control-prev, .hero .carousel-control-next {\n  transition: 0.3s;\n}\n.hero .carousel-control-prev:focus, .hero .carousel-control-next:focus {\n  opacity: 0.5;\n}\n.hero .carousel-control-prev:hover, .hero .carousel-control-next:hover {\n  opacity: 0.9;\n}\n.hero .carousel-indicators li {\n  cursor: pointer;\n  background: rgba(255,255,255, 0.8);\n  overflow: hidden;\n  border: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50px;\n  opacity: 0.6;\n  transition: 0.3s;\n}\n.hero .carousel-indicators li.active {\n  opacity: 1;\n  background: #ffec69;\n  width: 26px;\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n@-webkit-keyframes fadeInDownLite {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -10%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fadeInDownLite {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -10%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.featured-services .service-item {\n  padding: 30px;\n  transition: all ease-in-out 0.4s;\n  background: var(--color-white);\n  height: 100%;\n}\n.featured-services .service-item .icon {\n  margin-bottom: 10px;\n}\n.featured-services .service-item .icon i {\n  color: var(--color-primary);\n  font-size: 36px;\n  transition: 0.3s;\n}\n.featured-services .service-item h4 {\n  font-weight: 600;\n  margin-bottom: 15px;\n  font-size: 24px;\n}\n.featured-services .service-item h4 a {\n  color: var(--color-secondary);\n  transition: ease-in-out 0.3s;\n}\n.featured-services .service-item p {\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.featured-services .service-item:hover {\n  transform: translateY(-10px);\n  box-shadow: 0px 0 60px 0 rgba(var(--color-secondary-rgb), 0.1);\n}\n.featured-services .service-item:hover h4 a {\n  color: var(--color-primary);\n}\n\n\n.about .about-img {\n  position: relative;\n}\n\n.about .about-img img{width:100%;}\n\n@media (max-width: 575px) {\n  .about .about-img {\n    margin: 30px 0 0 30px;\n  }\n  .about .about-img:before {\n    inset: -30px 0 0 -30px;\n  }\n}\n.about h3 {\n  color: var(--color-secondary);\n  font-family: var(--font-secondary);\n  font-weight: 300;\n  font-size: 32px;\n  margin-bottom: 20px;\n}\n@media (max-width: 768px) {\n  .about h3 {\n    font-size: 28px;\n  }\n}\n.about .nav-pills {\n  border-bottom: 1px solid rgba(var(--color-secondary-rgb), 0.2);\n}\n.about .nav-pills li + li {\n  margin-left: 40px;\n}\n.about .nav-link {\n  background: none;\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--color-secondary);\n  padding: 12px 0;\n  margin-bottom: -2px;\n  border-radius: 0;\n  font-family: var(--font-secondary);\n}\n.about .nav-link.active {\n  color: var(--color-primary);\n  background: none;\n  border-bottom: 3px solid var(--color-primary);\n}\n@media (max-width: 575px) {\n  .about .nav-link {\n    font-size: 16px;\n  }\n}\n.about .tab-content h4 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 700;\n  color: var(--color-secondary);\n}\n.about .tab-content i {\n  font-size: 22px;\n  line-height: 0;\n  margin-right: 8px;\n  color: var(--color-primary);\n}\n\n\n.onfocus {\n  padding: 0;\n}\n\n@media (min-width: 768px) {\n  .onfocus .content {\n    padding: 80px;\n  }\n}\n.onfocus .content h3 {\n  font-weight: 600;\n  font-size: 32px;\n  color: var(--color-white);\n}\n.onfocus .content ul {\n  list-style: none;\n  padding: 0;\n}\n.onfocus .content ul li {\n  padding-bottom: 10px;\n}\n.onfocus .content ul i {\n  font-size: 20px;\n  padding-right: 4px;\n  color: var(--color-primary);\n}\n.onfocus .content p:last-child {\n  margin-bottom: 0;\n}\n.onfocus .content .read-more {\n  font-family: var(--font-primary);\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 1px;\n  padding: 12px 24px;\n  border-radius: 5px;\n  transition: 0.3s;\n  display: -nline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-white);\n  background: var(--color-primary);\n}\n.onfocus .content .read-more i {\n  font-size: 18px;\n  margin-left: 5px;\n  line-height: 0;\n  transition: 0.3s;\n}\n.onfocus .content .read-more:hover {\n  background: rgba(var(--color-primary-rgb), 0.9);\n  padding-right: 19px;\n}\n.onfocus .content .read-more:hover i {\n  margin-left: 10px;\n}\n.onfocus .play-btn {\n  width: 94px;\n  height: 94px;\n  background: radial-gradient(var(--color-primary) 50%, rgba(var(--color-primary-rgb), 0.4) 52%);\n  border-radius: 50%;\n  display: block;\n  position: absolute;\n  left: calc(50% - 47px);\n  top: calc(50% - 47px);\n  overflow: hidden;\n}\n.onfocus .play-btn:before {\n  content: \"\";\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation: pulsate-btn 2s;\n  animation: pulsate-btn 2s;\n  -webkit-animation-direction: forwards;\n  animation-direction: forwards;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: steps;\n  animation-timing-function: steps;\n  opacity: 1;\n  border-radius: 50%;\n  border: 5px solid rgba(var(--color-primary-rgb), 0.7);\n  top: -15%;\n  left: -15%;\n  background: rgba(198, 16, 0, 0);\n}\n.onfocus .play-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid var(--color-white);\n  z-index: 100;\n  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.onfocus .play-btn:hover:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border: none;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid var(--color-white);\n  z-index: 200;\n  -webkit-animation: none;\n  animation: none;\n  border-radius: 0;\n}\n.onfocus .play-btn:hover:after {\n  border-left: 15px solid var(--color-primary);\n  transform: scale(20);\n}\n\n@-webkit-keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n@keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n.features .nav-tabs {\n  border: 0;\n}\n.features .nav-link {\n  border: 0;\n  padding: 25px 20px;\n  color: var(--color-secondary);\n  box-shadow: 5px 5px 25px rgba(var(--color-secondary-rgb), 0.15);\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  transition: 0s;\n  cursor: pointer;\n  height: 100%;\n}\n.features .nav-link i {\n  font-size: 32px;\n  line-height: 0;\n}\n.features .nav-link h4 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 10px 0 0 0;\n  color: var(--color-secondary);\n}\n.features .nav-link:hover {\n  color: var(--color-primary);\n}\n.features .nav-link.active {\n  transition: 0.3s;\n  background: var(--color-red) linear-gradient(rgba(var(--color-primary-rgb), 0.95), rgba(var(--color-primary-rgb), 0.6));\n  border-color: var(--color-primary);\n}\n.features .nav-link.active h4 {\n  color: var(--color-white);\n}\n.features .nav-link.active i {\n  color: var(--color-white) !important;\n}\n.features .tab-content {\n  margin-top: 30px;\n}\n.features .tab-pane.active {\n  -webkit-animation: fadeIn 0.5s ease-out;\n  animation: fadeIn 0.5s ease-out;\n}\n.features .tab-pane h3 {\n  font-weight: 600;\n  font-size: 36px;\n  color: var(--color-secondary);\n}\n.features .tab-pane ul {\n  list-style: none;\n  padding: 0;\n}\n.features .tab-pane ul li {\n  padding-bottom: 10px;\n}\n.features .tab-pane ul i {\n  font-size: 24px;\n  margin-right: 4px;\n  color: var(--color-primary);\n}\n.features .tab-pane p:last-child {\n  margin-bottom: 0;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.services .img {\n  border-radius: 8px;\n  overflow: hidden;\n}\n.services .img img {\n  transition: 0.6s;\n}\n.services .details {\n  height:85px;\n  padding: 11px 10px;\n  margin: -33px 30px 0 30px;\n  transition: all ease-in-out 0.3s;\n  background: var(--color-white);\n  position: relative;\n  background: rgba(var(--color-white-rgb), 0.9);\n  text-align: center;\n  border-radius: 8px;\n  box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);\n}\n.services .details .icon {\n  margin: 0;\n  width:62px;\n  height: 62px;\n  background: var(--color-primary);\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  color: var(--color-white);\n  font-size: 25px;\n  transition: ease-in-out 0.3s;\n  position: absolute;\n  top: -40px;\n  left: calc(50% - 36px);\n  border: 6px solid var(--color-white);\n}\n.services .details h3 {\n  color: var(--color-default);\n  font-weight: 700;\n  margin:22px 0 8px 0;\n  font-size:16px;\n  transition: ease-in-out 0.3s;\n}\n.services .details p {\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n.services .service-item:hover .details h3 {\n  color: var(--color-primary);\n}\n.services .service-item:hover .details .icon {\n  background: var(--color-white);\n  border: 2px solid var(--color-primary);\n}\n.services .service-item:hover .details .icon i {\n  color: var(--color-primary);\n}\n.services .service-item:hover .img img {\n  transform: scale(1.2);\n}\n\n.testimonials::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(var(--color-secondary-dark-rgb), 0.8);\n}\n.testimonials .section-header {\n  margin-bottom: 40px;\n}\n.testimonials .testimonials-carousel, .testimonials .testimonials-slider {\n  overflow: hidden;\n}\n.testimonials .testimonial-item {\n  text-align: center;\n  color: var(--color-white);\n}\n.testimonials .testimonial-item .testimonial-img {\n  width: 100px;\n  border-radius: 50%;\n  border: 6px solid rgba(var(--color-white-rgb), 0.15);\n  margin: 0 auto;\n}\n.testimonials .testimonial-item h3 {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px 0 5px 0;\n  color: var(--color-white);\n}\n.testimonials .testimonial-item h4 {\n  font-size: 14px;\n  color: rgba(var(--color-white-rgb), 0.6);\n  margin: 0 0 15px 0;\n}\n.testimonials .testimonial-item .stars {\n  margin-bottom: 15px;\n}\n.testimonials .testimonial-item .stars i {\n  color: var(--color-yellow);\n  margin: 0 1px;\n}\n.testimonials .testimonial-item .quote-icon-left, .testimonials .testimonial-item .quote-icon-right {\n  color: rgba(var(--color-white-rgb), 0.6);\n  font-size: 26px;\n  line-height: 0;\n}\n.testimonials .testimonial-item .quote-icon-left {\n  display: inline-block;\n  left: -5px;\n  position: relative;\n}\n.testimonials .testimonial-item .quote-icon-right {\n  display: inline-block;\n  right: -5px;\n  position: relative;\n  top: 10px;\n  transform: scale(-1, -1);\n}\n.testimonials .testimonial-item p {\n  font-style: italic;\n  margin: 0 auto 15px auto;\n}\n.testimonials .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n.testimonials .swiper-pagination .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: rgba(var(--color-white-rgb), 0.4);\n  opacity: 0.5;\n}\n.testimonials .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--color-white);\n  opacity: 1;\n}\n@media (min-width: 992px) {\n  .testimonials .testimonial-item p {\n    width: 80%;\n  }\n}\n\n\n.pricing {\n  background: rgba(var(--color-secondary-rgb), 0.04);\n}\n.pricing .pricing-item {\n  padding: 60px 40px;\n  box-shadow: 0 3px 20px -2px rgba(var(--color-gray-rgb), 0.15);\n  background: var(--color-white);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 4px solid var(--color-white);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.pricing h3 {\n  font-weight: 600;\n  margin-bottom: 5px;\n  font-size: 36px;\n  color: var(--color-white);\n}\n.pricing h4 {\n  font-size: 48px;\n  color: var(--color-white);\n  font-weight: 400;\n  font-family: var(--font-primary);\n  margin-bottom: 0;\n}\n.pricing h4 sup {\n  font-size: 28px;\n}\n.pricing h4 span {\n  color: rgba(var(--color-white-rgb), 0.6);\n  font-size: 24px;\n}\n.pricing ul {\n  padding: 30px 0;\n  list-style: none;\n  color: var(--color-gray);\n  text-align: left;\n  line-height: 20px;\n}\n.pricing ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n.pricing ul i {\n  color: var(--color-primary);\n  font-size: 36px;\n  padding-right: 3px;\n  line-height: 0;\n}\n.pricing ul .na {\n  color: rgba(var(--color-gray-rgb), 0.5);\n}\n.pricing ul .na i {\n  color: rgba(var(--color-gray-rgb), 0.5);\n  font-size: 24px;\n  padding-left: 4px;\n}\n.pricing ul .na span {\n  text-decoration: line-through;\n}\n.pricing .buy-btn {\n  display: inline-block;\n  padding: 12px 40px;\n  border-radius: 6px;\n  color: var(--color-primary);\n  transition: none;\n  font-size: 16px;\n  font-weight: 700;\n  transition: 0.3s;\n  border: 1px solid var(--color-primary);\n}\n.pricing .buy-btn:hover {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n.pricing .featured {\n  border-color: var(--color-primary);\n}\n\n.pricing .featured .buy-btn {\n  background: var(--color-primary);\n  color: var(--color-white);\n}\n\n@media (max-width: 991px) {\n  .faq {\n    padding: 0;\n  }\n}\n.faq .content h3 {\n  font-weight: 400;\n  font-size: 34px;\n  color: var(--color-secondary);\n}\n.faq .content h4 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-top: 5px;\n}\n.faq .content p {\n  font-size: 15px;\n  color: var(--color-gray);\n}\n.faq .img {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  min-height: 400px;\n}\n.faq .accordion-item {\n  border: 0;\n  margin-top: 15px;\n  box-shadow: 0px 5px 25px 0px rgba(var(--color-black-rgb), 0.06);\n}\n.faq .accordion-collapse {\n  border: 0;\n}\n.faq .accordion-button {\n  padding: 15px 20px 20px 20px;\n  font-weight: 600;\n  border: 0;\n  font-size: 16px;\n  color: var(--color-default);\n  text-align: left;\n  background: var(--color-white);\n  box-shadow: none;\n  border-radius: 5px;\n}\n.faq .accordion-button:not(.collapsed) {\n  color: var(--color-primary);\n  border-bottom: 0;\n  box-shadow: none;\n}\n.faq .question-icon {\n  position: absolute;\n  top: 14px;\n  left: 25px;\n  font-size: 20px;\n  color: var(--color-primary);\n}\n.faq .accordion-button:after {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  color: var(--color-primary);\n}\n.faq .accordion-body {\n  padding: 0 30px 25px 20px;\n  border: 0;\n  border-radius: 5px;\n  background: var(--color-white);\n  box-shadow: none;\n}\n\n\n.portfolio .portfolio-flters {\n  padding: 0;\n  margin: 0 auto 30px auto;\n  list-style: none;\n  text-align: center;\n}\n.portfolio .portfolio-flters li {\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 300;\n  margin: 0 10px;\n  line-height: 1;\n  margin-bottom: 5px;\n  transition: all 0.3s ease-in-out;\n}\n.portfolio .portfolio-flters li:hover, .portfolio .portfolio-flters li.filter-active {\n  color: var(--color-primary);\n}\n.portfolio .portfolio-flters li:first-child {\n  margin-left: 0;\n}\n.portfolio .portfolio-flters li:last-child {\n  margin-right: 0;\n}\n@media (max-width: 575px) {\n  .portfolio .portfolio-flters li {\n    font-size: 14px;\n    margin: 0 5px;\n  }\n}\n.portfolio .portfolio-item {\n  position: relative;\n  border: 1px solid var(--color-white);\n  overflow: hidden;\n  z-index: 1;\n}\n.portfolio .portfolio-item img {\n  transition: all 0.3s;\n}\n.portfolio .portfolio-item:before {\n  content: \"\";\n  inset: 0;\n  position: absolute;\n  background: rgba(var(--color-secondary-rgb), 0.8);\n  z-index: 2;\n  transition: 0.5s;\n  visibility: hidden;\n  opacity: 0;\n}\n.portfolio .portfolio-item .portfolio-info {\n  opacity: 0;\n  position: absolute;\n  inset: auto 40px 40px 40px;\n  z-index: 3;\n  transition: all ease-in-out 0.3s;\n  padding: 20px;\n}\n.portfolio .portfolio-item .portfolio-info h4 {\n  font-size: 10px;\n  font-weight:normal;\n  color: var(--color-white);\n  padding-right: 50px;\n}\n.portfolio .portfolio-item .portfolio-info .preview-link, .portfolio .portfolio-item .portfolio-info .details-link {\n  position: absolute;\n  right: 50px;\n  font-size: 24px;\n  top: calc(50% - 14px);\n  color: rgba(var(--color-white-rgb), 0.7);\n  transition: 0.3s;\n  line-height: 0;\n}\n.portfolio .portfolio-item .portfolio-info .preview-link:hover, .portfolio .portfolio-item .portfolio-info .details-link:hover {\n  color: var(--color-white);\n}\n.portfolio .portfolio-item .portfolio-info .details-link {\n  right: 14px;\n  font-size: 28px;\n}\n.portfolio .portfolio-item:hover:before {\n  visibility: visible;\n  opacity: 1;\n}\n.portfolio .portfolio-item:hover img {\n  transform: scale(1.2);\n}\n.portfolio .portfolio-item:hover .portfolio-info {\n  opacity: 1;\n  inset: auto 10px 0 10px;\n}\n\n.team .team-member .member-img {\n  border-radius: 8px;\n  overflow: hidden;\n}\n.team .team-member .social {\n  position: absolute;\n  left: 0;\n  top: -18px;\n  right: 0;\n  opacity: 0;\n  transition: ease-in-out 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.team .team-member .social a {\n  transition: color 0.3s;\n  color: var(--color-white);\n  background: var(--color-primary);\n  margin: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  transition: 0.3s;\n}\n.team .team-member .social a i {\n  line-height: 0;\n  font-size: 16px;\n}\n.team .team-member .social a:hover {\n  background: var(--color-primary-light);\n}\n.team .team-member .social i {\n  font-size: 18px;\n  margin: 0 2px;\n}\n.team .team-member .member-info {\n  padding: 30px 15px;\n  text-align: center;\n  box-shadow: 0px 2px 15px rgba(var(--color-black-rgb), 0.1);\n  background: var(--color-white);\n  margin: -50px 20px 0 20px;\n  position: relative;\n  border-radius: 8px;\n}\n.team .team-member .member-info h4 {\n  font-weight: 400;\n  margin-bottom: 5px;\n  font-size: 24px;\n  color: var(--color-secondary);\n}\n.team .team-member .member-info span {\n  display: block;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--color-gray);\n}\n.team .team-member .member-info p {\n  font-style: italic;\n  font-size: 14px;\n  line-height: 26px;\n  color: var(--color-gray);\n}\n.team .team-member:hover .social {\n  opacity: 1;\n}\n\n.recent-blog-posts .post-box {\n  transition: 0.3s;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.recent-blog-posts .post-box .post-img {\n  overflow: hidden;\n  position: relative;\n  border-radius: 10px;\n}\n.recent-blog-posts .post-box .post-img img {\n  transition: 0.5s;\n}\n.recent-blog-posts .post-box .meta {\n  margin-top: 15px;\n}\n.recent-blog-posts .post-box .meta .post-date {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--color-primary);\n}\n.recent-blog-posts .post-box .meta .post-author {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--color-secondary);\n}\n.recent-blog-posts .post-box .post-title {\n  font-size: 24px;\n  color: var(--color-secondary);\n  font-weight: 700;\n  margin: 15px 0 0 0;\n  position: relative;\n  transition: 0.3s;\n}\n.recent-blog-posts .post-box p {\n  margin: 15px 0 0 0;\n  color: rgba(var(--color-secondary-dark-rgb), 0.7);\n}\n.recent-blog-posts .post-box .readmore {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n  transition: 0.3s;\n  margin-top: 15px;\n}\n.recent-blog-posts .post-box .readmore i {\n  line-height: 0;\n  margin-left: 4px;\n  font-size: 18px;\n}\n.recent-blog-posts .post-box:hover .post-title {\n  color: var(--color-primary);\n}\n.recent-blog-posts .post-box:hover .post-img img {\n  transform: scale(1.1);\n}\n\n.contact .map {\n  margin-bottom: 40px;\n}\n.contact .map iframe {\n  border: 0;\n  width: 100%;\n  height: 400px;\n}\n.contact .info {\n  padding: 40px;\n  box-shadow: 0px 2px 15px rgba(var(--color-black-rgb), 0.1);\n  overflow: hidden;\n}\n.contact .info h3 {\n  font-weight: 600;\n  font-size: 24px;\n}\n.contact .info p {\n  color: var(--color-secondary-light);\n  margin-bottom: 30px;\n  font-size: 15px;\n}\n.contact .info-item + .info-item {\n  padding-top: 20px;\n  margin-top: 20px;\n  border-top: 1px solid rgba(var(--color-secondary-rgb), 0.15);\n}\n.contact .info-item i {\n  font-size: 24px;\n  color: var(--color-primary);\n  transition: all 0.3s ease-in-out;\n  margin-right: 20px;\n}\n.contact .info-item h4 {\n  padding: 0;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: var(--color-secondary);\n}\n.contact .info-item p {\n  padding: 0;\n  margin-bottom: 0;\n  font-size: 14px;\n  color: var(--color-secondary-light);\n}\n.contact .php-email-form {\n  width: 100%;\n  background: var(--color-white);\n}\n.contact .php-email-form .form-group {\n  padding-bottom: 8px;\n}\n.contact .php-email-form .error-message {\n  display: none;\n  color: var(--color-white);\n  background: var(--color-red);\n  text-align: left;\n  padding: 15px;\n  font-weight: 600;\n}\n.contact .php-email-form .error-message br + br {\n  margin-top: 25px;\n}\n.contact .php-email-form .sent-message {\n  display: none;\n  color: var(--color-white);\n  background: var(--color-green);\n  text-align: center;\n  padding: 15px;\n  font-weight: 600;\n}\n.contact .php-email-form .loading {\n  display: none;\n  background: var(--color-white);\n  text-align: center;\n  padding: 15px;\n}\n.contact .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid var(--color-green);\n  border-top-color: var(--color-white);\n  -webkit-animation: animate-loading 1s linear infinite;\n  animation: animate-loading 1s linear infinite;\n}\n.contact .php-email-form input[type=text], .contact .php-email-form input[type=email], .contact .php-email-form textarea {\n  border-radius: 0px;\n  box-shadow: none;\n  font-size: 14px;\n}\n.contact .php-email-form input[type=text]:focus, .contact .php-email-form input[type=email]:focus, .contact .php-email-form textarea:focus {\n  border-color: var(--color-secondary-light);\n}\n.contact .php-email-form input[type=text], .contact .php-email-form input[type=email] {\n  height: 48px;\n  padding: 10px 15px;\n}\n.contact .php-email-form textarea {\n  padding: 10px 12px;\n  height: 290px;\n}\n.contact .php-email-form button[type=submit] {\n  background: var(--color-primary);\n  border: 0;\n  padding: 13px 50px;\n  color: var(--color-white);\n  transition: 0.4s;\n  border-radius: 0;\n}\n.contact .php-email-form button[type=submit]:hover {\n  background: rgba(var(--color-primary-rgb), 0.85);\n}\n@-webkit-keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.portfolio-details {\n  padding-top: 40px;\n}\n.portfolio-details .portfolio-details-slider img {\n  width: 100%;\n}\n.portfolio-details .portfolio-details-slider .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: var(--color-white);\n  opacity: 1;\n  border: 1px solid var(--color-primary);\n}\n.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--color-primary);\n}\n.portfolio-details .portfolio-info {\n  padding: 30px;\n  box-shadow: 0px 0 30px rgba(var(--color-secondary-rgb), 0.15);\n}\n.portfolio-details .portfolio-info h3 {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--color-secondary-light);\n}\n.portfolio-details .portfolio-info ul {\n  list-style: none;\n  padding: 0;\n  font-size: 15px;\n}\n.portfolio-details .portfolio-info ul li + li {\n  margin-top: 10px;\n}\n.portfolio-details .portfolio-description {\n  padding-top: 30px;\n}\n.portfolio-details .portfolio-description h2 {\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.portfolio-details .portfolio-description p {\n  padding: 0;\n}\n\n\n.blog .posts-list article {\n  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);\n  padding: 30px;\n  height: 100%;\n}\n.blog .posts-list article + article {\n  margin-top: 60px;\n}\n.blog .posts-list .post-img {\n  max-height: 240px;\n  margin: -30px -30px 0 -30px;\n  overflow: hidden;\n}\n.blog .posts-list .title {\n  font-size: 24px;\n  font-weight: 700;\n  padding: 0;\n  margin: 20px 0 0 0;\n}\n.blog .posts-list .title a {\n  color: var(--color-secondary);\n  transition: 0.3s;\n}\n.blog .posts-list .title a:hover {\n  color: var(--color-primary);\n}\n.blog .posts-list .meta-top {\n  margin-top: 20px;\n  color: var(--color-gray);\n}\n.blog .posts-list .meta-top ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n.blog .posts-list .meta-top ul li + li {\n  padding-left: 20px;\n}\n.blog .posts-list .meta-top i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  color: rgba(var(--color-primary-rgb), 0.8);\n}\n.blog .posts-list .meta-top a {\n  color: var(--color-gray);\n  font-size: 14px;\n  display: inline-block;\n  line-height: 1;\n}\n.blog .posts-list .content {\n  margin-top: 20px;\n}\n.blog .posts-list .read-more a {\n  display: inline-block;\n  background: var(--color-primary);\n  color: var(--color-white);\n  padding: 8px 30px;\n  transition: 0.3s;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.blog .posts-list .read-more a:hover {\n  background: rgba(var(--color-primary-rgb), 0.8);\n}\n\n.blog .blog-details {\n  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);\n  padding: 30px;\n}\n.blog .blog-details .post-img {\n  margin: -30px -30px 20px -30px;\n  overflow: hidden;\n}\n.blog .blog-details .title {\n  font-size: 28px;\n  font-weight: 700;\n  padding: 0;\n  margin: 20px 0 0 0;\n  color: var(--color-secondary);\n}\n.blog .blog-details .content {\n  margin-top: 20px;\n}\n.blog .blog-details .content h3 {\n  font-size: 22px;\n  margin-top: 30px;\n  font-weight: bold;\n}\n.blog .blog-details .content blockquote {\n  overflow: hidden;\n  background-color: rgba(var(--color-secondary-rgb), 0.06);\n  padding: 60px;\n  position: relative;\n  text-align: center;\n  margin: 20px 0;\n}\n.blog .blog-details .content blockquote p {\n  color: var(--color-default);\n  line-height: 1.6;\n  margin-bottom: 0;\n  font-style: italic;\n  font-weight: 500;\n  font-size: 22px;\n}\n.blog .blog-details .content blockquote:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background-color: var(--color-secondary);\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.blog .blog-details .meta-top {\n  margin-top: 20px;\n  color: var(--color-gray);\n}\n.blog .blog-details .meta-top ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n.blog .blog-details .meta-top ul li + li {\n  padding-left: 20px;\n}\n.blog .blog-details .meta-top i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  color: rgba(var(--color-primary-rgb), 0.8);\n}\n.blog .blog-details .meta-top a {\n  color: var(--color-gray);\n  font-size: 14px;\n  display: inline-block;\n  line-height: 1;\n}\n.blog .blog-details .meta-bottom {\n  padding-top: 10px;\n  border-top: 1px solid rgba(var(--color-secondary-rgb), 0.15);\n}\n.blog .blog-details .meta-bottom i {\n  color: var(--color-secondary-light);\n  display: inline;\n}\n.blog .blog-details .meta-bottom a {\n  color: rgba(var(--color-secondary-rgb), 0.8);\n  transition: 0.3s;\n}\n.blog .blog-details .meta-bottom a:hover {\n  color: var(--color-primary);\n}\n.blog .blog-details .meta-bottom .cats {\n  list-style: none;\n  display: inline;\n  padding: 0 20px 0 0;\n  font-size: 14px;\n}\n.blog .blog-details .meta-bottom .cats li {\n  display: inline-block;\n}\n.blog .blog-details .meta-bottom .tags {\n  list-style: none;\n  display: inline;\n  padding: 0;\n  font-size: 14px;\n}\n.blog .blog-details .meta-bottom .tags li {\n  display: inline-block;\n}\n.blog .blog-details .meta-bottom .tags li + li::before {\n  padding-right: 6px;\n  color: var(--color-default);\n  content: \",\";\n}\n.blog .blog-details .meta-bottom .share {\n  font-size: 16px;\n}\n.blog .blog-details .meta-bottom .share i {\n  padding-left: 5px;\n}\n.blog .post-author {\n  padding: 20px;\n  margin-top: 30px;\n  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);\n}\n.blog .post-author img {\n  max-width: 120px;\n  margin-right: 20px;\n}\n.blog .post-author h4 {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 0px;\n  padding: 0;\n  color: var(--color-secondary);\n}\n.blog .post-author .social-links {\n  margin: 0 10px 10px 0;\n}\n.blog .post-author .social-links a {\n  color: rgba(var(--color-secondary-rgb), 0.5);\n  margin-right: 5px;\n}\n.blog .post-author p {\n  font-style: italic;\n  color: rgba(var(--color-gray-rgb), 0.8);\n  margin-bottom: 0;\n}\n\n.blog .sidebar {\n  padding: 30px;\n  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);\n}\n.blog .sidebar .sidebar-title {\n  font-size: 20px;\n  font-weight: 700;\n  padding: 0;\n  margin: 0;\n  color: var(--color-secondary);\n}\n.blog .sidebar .sidebar-item + .sidebar-item {\n  margin-top: 40px;\n}\n.blog .sidebar .search-form form {\n  background: var(--color-white);\n  border: 1px solid rgba(var(--color-secondary-rgb), 0.3);\n  padding: 3px 10px;\n  position: relative;\n}\n.blog .sidebar .search-form form input[type=text] {\n  border: 0;\n  padding: 4px;\n  border-radius: 4px;\n  width: calc(100% - 40px);\n}\n.blog .sidebar .search-form form input[type=text]:focus {\n  outline: none;\n}\n.blog .sidebar .search-form form button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border: 0;\n  background: none;\n  font-size: 16px;\n  padding: 0 15px;\n  margin: -1px;\n  background: var(--color-primary);\n  color: var(--color-white);\n  transition: 0.3s;\n  border-radius: 0 4px 4px 0;\n  line-height: 0;\n}\n.blog .sidebar .search-form form button i {\n  line-height: 0;\n}\n.blog .sidebar .search-form form button:hover {\n  background: rgba(var(--color-primary-rgb), 0.8);\n}\n.blog .sidebar .categories ul {\n  list-style: none;\n  padding: 0;\n}\n.blog .sidebar .categories ul li + li {\n  padding-top: 10px;\n}\n.blog .sidebar .categories ul a {\n  color: var(--color-secondary);\n  transition: 0.3s;\n}\n.blog .sidebar .categories ul a:hover {\n  color: var(--color-default);\n}\n.blog .sidebar .categories ul a span {\n  padding-left: 5px;\n  color: rgba(var(--color-default-rgb), 0.4);\n  font-size: 14px;\n}\n.blog .sidebar .recent-posts .post-item {\n  display: flex;\n}\n.blog .sidebar .recent-posts .post-item + .post-item {\n  margin-top: 15px;\n}\n.blog .sidebar .recent-posts img {\n  width: 80px;\n  margin-right: 15px;\n}\n.blog .sidebar .recent-posts h4 {\n  font-size: 18px;\n  font-weight: 400;\n}\n.blog .sidebar .recent-posts h4 a {\n  color: var(--color-secondary);\n  transition: 0.3s;\n}\n.blog .sidebar .recent-posts h4 a:hover {\n  color: var(--color-primary);\n}\n.blog .sidebar .recent-posts time {\n  display: block;\n  font-style: italic;\n  font-size: 14px;\n  color: rgba(var(--color-default-rgb), 0.4);\n}\n.blog .sidebar .tags {\n  margin-bottom: -10px;\n}\n.blog .sidebar .tags ul {\n  list-style: none;\n  padding: 0;\n}\n.blog .sidebar .tags ul li {\n  display: inline-block;\n}\n.blog .sidebar .tags ul a {\n  color: var(--color-secondary-light);\n  font-size: 14px;\n  padding: 6px 14px;\n  margin: 0 6px 8px 0;\n  border: 1px solid rgba(var(--color-secondary-light-rgb), 0.8);\n  display: inline-block;\n  transition: 0.3s;\n}\n.blog .sidebar .tags ul a:hover {\n  color: var(--color-white);\n  border: 1px solid var(--color-primary);\n  background: var(--color-primary);\n}\n.blog .sidebar .tags ul a span {\n  padding-left: 5px;\n  color: rgba(var(--color-secondary-light-rgb), 0.8);\n  font-size: 14px;\n}\n\n.blog .comments {\n  margin-top: 30px;\n}\n.blog .comments .comments-count {\n  font-weight: bold;\n}\n.blog .comments .comment {\n  margin-top: 30px;\n  position: relative;\n}\n.blog .comments .comment .comment-img {\n  margin-right: 14px;\n}\n.blog .comments .comment .comment-img img {\n  width: 60px;\n}\n.blog .comments .comment h5 {\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n.blog .comments .comment h5 a {\n  font-weight: bold;\n  color: var(--color-default);\n  transition: 0.3s;\n}\n.blog .comments .comment h5 a:hover {\n  color: var(--color-primary);\n}\n.blog .comments .comment h5 .reply {\n  padding-left: 10px;\n  color: var(--color-secondary);\n}\n.blog .comments .comment h5 .reply i {\n  font-size: 20px;\n}\n.blog .comments .comment time {\n  display: block;\n  font-size: 14px;\n  color: rgba(var(--color-secondary-rgb), 0.8);\n  margin-bottom: 5px;\n}\n.blog .comments .comment.comment-reply {\n  padding-left: 40px;\n}\n.blog .comments .reply-form {\n  margin-top: 30px;\n  padding: 30px;\n  box-shadow: 0 4px 16px rgba(var(--color-black-rgb), 0.1);\n}\n.blog .comments .reply-form h4 {\n  font-weight: bold;\n  font-size: 22px;\n}\n.blog .comments .reply-form p {\n  font-size: 14px;\n}\n.blog .comments .reply-form input {\n  border-radius: 4px;\n  padding: 10px 10px;\n  font-size: 14px;\n}\n.blog .comments .reply-form input:focus {\n  box-shadow: none;\n  border-color: rgba(var(--color-primary-rgb), 0.8);\n}\n.blog .comments .reply-form textarea {\n  border-radius: 4px;\n  padding: 10px 10px;\n  font-size: 14px;\n}\n.blog .comments .reply-form textarea:focus {\n  box-shadow: none;\n  border-color: rgba(var(--color-primary-rgb), 0.8);\n}\n.blog .comments .reply-form .form-group {\n  margin-bottom: 25px;\n}\n.blog .comments .reply-form .btn-primary {\n  border-radius: 4px;\n  padding: 10px 20px;\n  border: 0;\n  background-color: var(--color-secondary);\n}\n.blog .comments .reply-form .btn-primary:hover {\n  background-color: rgba(var(--color-secondary-rgb), 0.8);\n}\n\n.blog .blog-pagination {\n  margin-top: 30px;\n  color: var(--color-secondary-light);\n}\n.blog .blog-pagination ul {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.blog .blog-pagination li {\n  margin: 0 5px;\n  transition: 0.3s;\n}\n.blog .blog-pagination li a {\n  color: var(--color-secondary);\n  padding: 7px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.blog .blog-pagination li.active, .blog .blog-pagination li:hover {\n  background: var(--color-primary);\n}\n.blog .blog-pagination li.active a, .blog .blog-pagination li:hover a {\n  color: var(--color-white);\n}\n\n.footer {\n  color: var(--color-white);\n  font-size: 14px;\n}\n.footer .footer-content {\n  background: var(--color-secondary);\n  padding: 30px 0 5px 0;\n}\n.footer .footer-content .footer-info {\n  margin-bottom: 30px;\n}\n.footer .footer-content .footer-info h3 {\n  font-size: 28px;\n  margin: 0 0 20px 0;\n  padding: 2px 0 2px 0;\n  line-height: 1;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.footer .footer-content .footer-info h3 span {\n  color: var(--color-primary);\n}\n.footer .footer-content .footer-info p {\n  font-size: 14px;\n  line-height: 24px;\n  margin-bottom: 0;\n  font-family: var(--font-primary);\n  color: var(--color-white);\n}\n.footer .footer-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-white);\n  position: relative;\n  padding-bottom: 12px;\n  margin-bottom: 15px;\n}\n.footer .footer-content h4::after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 20px;\n  height: 2px;\n  background: var(--color-primary);\n  bottom: 0;\n  left: 0;\n}\n.footer .footer-content .footer-links {\n  margin-bottom:10px;\n}\n.footer .footer-content .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.footer .footer-content .footer-links ul i {\n  padding-right: 2px;\n  color: var(--color-white);\n  font-size: 12px;\n  line-height: 1;\n}\n.footer .footer-content .footer-links ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n.footer .footer-content .footer-links ul li:first-child {\n  padding-top: 0;\n}\n.footer .footer-content .footer-links ul a {\n  color: rgba(var(--color-white-rgb), 0.7);\n  transition: 0.3s;\n  display: inline-block;\n  line-height: 1;\n}\n.footer .footer-content .footer-links ul a:hover {\n  color: var(--color-white);\n}\n.footer .footer-content .footer-newsletter form {\n  margin-top: 30px;\n  background: var(--color-white);\n  padding: 6px 10px;\n  position: relative;\n  border-radius: 4px;\n}\n.footer .footer-content .footer-newsletter form input[type=email] {\n  border: 0;\n  padding: 4px;\n  width: calc(100% - 110px);\n}\n.footer .footer-content .footer-newsletter form input[type=email]:focus-visible {\n  outline: none;\n}\n.footer .footer-content .footer-newsletter form input[type=submit] {\n  position: absolute;\n  top: 0;\n  right: -2px;\n  bottom: 0;\n  border: 0;\n  background: none;\n  font-size: 16px;\n  padding: 0 20px;\n  background: #ffde00;\n  color: #000;\n  transition: 0.3s;\n  border-radius: 0 4px 4px 0;\n}\n.footer .footer-content .footer-newsletter form input[type=submit]:hover {\n  background: rgba(var(--color-primary-rgb), 0.85);\n}\n.footer .footer-legal {\n  padding: 10px 0;\n  background: var(--color-secondary-dark);\n}\n.footer .footer-legal .credits {\n  padding-top: 4px;\n  font-size: 13px;\n  color: var(--color-white);\n}\n.footer .footer-legal .credits a {\n  color: var(--color-primary-light);\n}\n.footer .footer-legal .social-links a {\n  font-size: 18px;\n  display: inline-block;\n  background: rgba(var(--color-white-rgb), 0.1);\n  color: var(--color-white);\n  line-height: 1;\n  padding: 8px 0;\n  margin-right: 4px;\n  border-radius: 4px;\n  text-align: center;\n  width: 36px;\n  height: 36px;\n  transition: 0.3s;\n}\n.footer .footer-legal .social-links a:hover {\n  background: var(--color-primary);\n  text-decoration: none;\n}\n\n\n.min-high1{ height: 530px !important; overflow: scroll !important; overflow-x: hidden !important;}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
